<div class="space-y-3 sm:space-y-6 pb-20 sm:pb-8">
  <!-- Top Header & Market Budget Summary (Material Surface) -->
  <div class="flex flex-col md:flex-row md:items-center md:justify-between gap-3 sm:gap-4 bg-white dark:bg-slate-900 p-3 sm:p-5 rounded-xl sm:rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs dark:shadow-md transition-colors">
    <div>
      <div class="flex items-center space-x-2">
        <h2 class="text-xl font-bold text-slate-900 dark:text-white">{{ game.t('market.title') }}</h2>
      </div>
      <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">
        {{ game.t('market.desc') }}
      </p>
    </div>

    <!-- Right Indicators: Balances -->
    <div class="grid grid-cols-2 gap-2.5 w-full md:w-auto md:shrink-0">
      <!-- Available Balance Pill -->
      <div class="flex items-center gap-2 sm:gap-3 bg-slate-50 dark:bg-slate-950 px-2.5 sm:px-4 py-2 rounded-xl border border-slate-200 dark:border-slate-800 shadow-xs">
        <app-icon name="coins" [size]="20" class="text-emerald-600 dark:text-emerald-400" />
        <div>
          <div class="text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400">{{ game.t('market.available_balance') }}</div>
          <div class="text-base font-bold text-emerald-700 dark:text-emerald-400 font-mono">
            {{ game.userClub().economy.availableBalance.toFixed(2) }} M€
          </div>
        </div>
      </div>
      <!-- Reserved Funds Pill -->
      <div class="flex items-center gap-2 sm:gap-3 bg-slate-50 dark:bg-slate-950 px-2.5 sm:px-4 py-2 rounded-xl border border-slate-200 dark:border-slate-800 shadow-xs" title="Traspasos + fichas de ofertas">
        <app-icon name="coins" [size]="20" class="shrink-0 text-amber-600 dark:text-amber-400" />
        <div>
          <div class="text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400">Fondos Reservados</div>
          <div class="text-base font-bold text-amber-700 dark:text-amber-400 font-mono">
            {{ totalCommittedFundsM().toFixed(2) }} M€
          </div>
        </div>
      </div>
      <div data-testid="daily-bidding-countdown" class="col-span-2 flex flex-wrap items-center justify-between gap-2 rounded-xl border border-slate-700 bg-gradient-to-r from-slate-900 to-slate-800 px-3 py-2.5 text-white">
        <div>
          <div class="text-[10px] uppercase font-bold tracking-wide text-emerald-300">{{ game.t('market.daily_bidding') }}</div>
          <div class="text-[10px] text-slate-400 mt-0.5">{{ game.t('market.closes_at') }}: {{ dailyClosesAtFormatted() || '—' }}</div>
        </div>
        <div class="flex items-center gap-2 rounded-lg border border-white/10 bg-black/30 px-2.5 py-1.5 shrink-0">
          <app-icon name="clock" [size]="16" class="text-amber-400" />
          <span class="text-sm font-bold font-mono" [ngClass]="isDailyMarketClosed() ? 'text-rose-400' : 'text-amber-300'">{{ dailyTimeLeft() || '--:--:--' }}</span>
        </div>
      </div>
    </div>
  </div>

  <!-- Navigation Canonical Tabs (Mercado, Entrenadores, Cartera) -->
  <div class="flex bg-slate-100 dark:bg-slate-900 p-1.5 rounded-2xl border border-slate-200 dark:border-slate-800 space-x-1 sm:space-x-2">
    <!-- Tab 1: Mercado -->
    <button
      type="button"
      (click)="setTab('market')"
      id="market-tab-market"
      class="flex-1 flex items-center justify-center space-x-2 py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all cursor-pointer"
      [ngClass]="activeTab === 'market' ? 'bg-white dark:bg-slate-800 text-emerald-700 dark:text-emerald-400 shadow-sm border border-slate-200/80 dark:border-slate-700' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
    >
      <app-icon name="shirt" [size]="16" />
      <span>{{ game.t('market.tab_market') }}</span>
    </button>

    <!-- Tab 2: Entrenadores -->
    <button
      type="button"
      (click)="setTab('coaches')"
      id="market-tab-coaches"
      class="flex-1 flex items-center justify-center space-x-2 py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all cursor-pointer"
      [ngClass]="activeTab === 'coaches' ? 'bg-white dark:bg-slate-800 text-emerald-700 dark:text-emerald-400 shadow-sm border border-slate-200/80 dark:border-slate-700' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
    >
      <app-icon name="user" [size]="16" />
      <span>{{ game.t('coaches.title') }}</span>
    </button>

    <!-- Tab 3: Cartera -->
    <button
      type="button"
      (click)="setTab('watchlist')"
      id="market-tab-watchlist"
      class="flex-1 flex items-center justify-center space-x-2 py-2.5 rounded-xl text-xs sm:text-sm font-semibold transition-all cursor-pointer"
      [ngClass]="activeTab === 'watchlist' ? 'bg-white dark:bg-slate-800 text-emerald-700 dark:text-emerald-400 shadow-sm border border-slate-200/80 dark:border-slate-700' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
    >
      <app-icon name="bookmark" [size]="16" />
      <span>{{ game.t('market.tab_watchlist') }}</span>
      @if (watchlistCount() > 0) {
        <span
          class="text-[10px] px-1.5 py-0.5 rounded-md font-mono font-bold"
          [ngClass]="activeTab === 'watchlist' ? 'bg-blue-100 text-blue-800 dark:bg-blue-950 dark:text-blue-300' : 'bg-slate-200 dark:bg-slate-800 text-slate-600 dark:text-slate-400'"
        >
          {{ watchlistCount() }}
        </span>
      }
    </button>
  </div>

  <!-- ========================================== -->
  <!-- TAB 1: MERCADO (VISTA PRINCIPAL DEL MERCADO) -->
  <!-- ========================================== -->
  @if (activeTab === 'market') {
    <div class="space-y-6">
      <!-- Tabs Control & Filters -->
      <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-xl border border-slate-200 dark:border-slate-800 space-x-1 overflow-x-auto shrink-0">
          <button
            type="button"
            (click)="selectMarketTab('market')"
            class="flex items-center space-x-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap shrink-0"
            [ngClass]="activeMarketTab === 'market' ? 'bg-emerald-600 text-white shadow-xs' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
          >
            <app-icon name="shield" [size]="15" />
            <span>{{ game.t('market.subtab_market') }}</span>
            @if (isLoadingFreeAgents()) {
              <span class="inline-flex items-center px-1.5 py-0.5 rounded-full text-[10px] bg-emerald-500/40 text-white animate-pulse">
                {{ game.t('market.loading_agents') }}
              </span>
            } @else {
              <span>({{ marketCount() }})</span>
            }
          </button>

          <button
            type="button"
            (click)="selectMarketTab('my_sales')"
            class="flex items-center space-x-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap shrink-0"
            [ngClass]="activeMarketTab === 'my_sales' ? 'bg-emerald-600 text-white shadow-xs' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
          >
            <app-icon name="coins" [size]="15" />
            <span>{{ game.t('market.subtab_my_sales') }} ({{ mySalesPendingOffersCount() }})</span>
          </button>
          <button
            type="button"
            (click)="selectMarketTab('offers')"
            id="market-tab-offers"
            class="flex items-center space-x-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap shrink-0"
            [ngClass]="activeMarketTab === 'offers' ? 'bg-emerald-600 text-white shadow-xs' : 'text-slate-600 dark:text-slate-400 hover:text-slate-900 dark:hover:text-white'"
          >
            <app-icon name="file-text" [size]="15" />
            <span>{{ game.t('market.tab_offers') }}</span>
            @if (activeOffersCount() > 0) {
              <span>({{ activeOffersCount() }})</span>
            }
          </button>
        </div>

        <!-- Filters (solo visibles en pestaña Mercado) -->
        @if (activeMarketTab === 'market') {
        <div class="flex flex-wrap items-center gap-2">
          <!-- Filtro Solo Libres (en la pestaña de Mercado) -->
          @if (activeMarketTab === 'market') {
            <button
              type="button"
              (click)="onlyClubPlayers = !onlyClubPlayers; onlyFreeAgents = false"
              [attr.aria-pressed]="onlyClubPlayers"
              class="flex items-center px-3 py-2 rounded-xl text-xs font-semibold border transition-all cursor-pointer select-none"
              [ngClass]="onlyClubPlayers
                ? 'bg-emerald-600 text-white border-emerald-600 shadow-xs'
                : 'bg-white dark:bg-slate-950 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-800 hover:bg-slate-100 dark:hover:bg-slate-900'"
            >Solo de clubes</button>
            <button
              type="button"
              (click)="onlyFreeAgents = !onlyFreeAgents; onlyClubPlayers = false"
              [attr.aria-pressed]="onlyFreeAgents"
              class="flex items-center space-x-1.5 px-3 py-2 rounded-xl text-xs font-semibold border transition-all cursor-pointer select-none"
              [ngClass]="onlyFreeAgents
                ? 'bg-emerald-600 text-white border-emerald-600 shadow-xs'
                : 'bg-white dark:bg-slate-950 text-slate-700 dark:text-slate-300 border-slate-200 dark:border-slate-800 hover:bg-slate-100 dark:hover:bg-slate-900'"
            >
              <app-icon name="sparkles" [size]="13" />
              <span>{{ game.t('market.only_free') }}</span>
              @if (isLoadingFreeAgents()) {
                <div class="w-3 h-3 border-2 border-current border-t-transparent rounded-full animate-spin"></div>
              } @else {
                <span
                  class="text-[10px] px-1.5 py-0.2 rounded-md font-mono font-bold"
                  [ngClass]="onlyFreeAgents ? 'bg-white/20 text-white' : 'bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-400'"
                >
                  {{ game.freeAgents().length }}
                </span>
              }
            </button>
          }

          <!-- Filtro por Posición -->
          <div class="flex items-center space-x-1 text-xs">
            @for (pos of ['ALL', 'POR', 'DEF', 'MED', 'DEL']; track pos) {
              <button
                type="button"
                (click)="filterPos = pos"
                class="px-2.5 py-2 rounded-xl font-semibold transition-colors cursor-pointer"
                [ngClass]="filterPos === pos ? 'bg-emerald-600 text-white shadow-xs' : 'bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-900 dark:hover:text-white'"
              >
                {{ pos === 'ALL' ? game.t('common.all') : pos === 'POR' ? game.t('market.filter_gk') : pos === 'DEF' ? game.t('market.filter_def') : pos === 'MED' ? game.t('market.filter_mid') : game.t('market.filter_att') }}
              </button>
            }
          </div>
        </div>
        }
        @if (activeMarketTab === 'offers') {
          <div aria-label="Filtrar ofertas" class="flex flex-nowrap items-center gap-1 sm:gap-2 overflow-x-auto min-w-0 max-w-full">
            <button type="button" (click)="toggleOfferListFilter('active')"
              [attr.aria-pressed]="offerListFilter !== 'history'"
              class="px-2 sm:px-2.5 py-2 rounded-xl text-xs font-semibold whitespace-nowrap shrink-0 transition-colors cursor-pointer"
              [ngClass]="offerListFilter !== 'history' ? 'bg-emerald-600 text-white shadow-xs' : 'bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-900 dark:hover:text-white'">Activas</button>
            <button type="button" (click)="toggleOfferListFilter('history')"
              [attr.aria-pressed]="offerListFilter !== 'active'"
              class="px-2 sm:px-2.5 py-2 rounded-xl text-xs font-semibold whitespace-nowrap shrink-0 transition-colors cursor-pointer"
              [ngClass]="offerListFilter !== 'active' ? 'bg-emerald-600 text-white shadow-xs' : 'bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-900 dark:hover:text-white'">Históricas</button>
            @for (status of ['WON', 'LOST', 'CANCELLED']; track status) {
              <button type="button" (click)="setHistoryStatusFilter(status)"
                [attr.aria-pressed]="offerListFilter !== 'active' && historyFilterStatus === status"
                class="px-2 sm:px-2.5 py-2 rounded-xl text-xs font-semibold whitespace-nowrap shrink-0 transition-colors cursor-pointer"
                [ngClass]="offerListFilter !== 'active' && historyFilterStatus === status ? 'bg-emerald-600 text-white shadow-xs' : 'bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-900 dark:hover:text-white'">
                {{ status === 'WON' ? 'Ganadas' : status === 'LOST' ? 'Perdidas' : 'Canceladas' }}
              </button>
            }
          </div>
        }
      </div>

      @if (activeMarketTab === 'market') {
      <!-- Error Alert -->
      @if (loadError() && activeMarketTab === 'market') {
        <div class="p-4 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-xs text-amber-800 dark:text-amber-300 flex items-start justify-between gap-3">
          <div class="flex items-start space-x-2">
            <app-icon name="alert-triangle" [size]="16" class="shrink-0 mt-0.5" />
            <div>
              <div class="font-bold">Aviso del servidor de mercado</div>
              <div class="mt-0.5 text-[11px] opacity-90">{{ loadError() }}</div>
            </div>
          </div>
          <button
            type="button"
            (click)="loadFreeAgents(true)"
            class="px-3 py-1 bg-amber-600 hover:bg-amber-700 text-white rounded-lg text-xs font-semibold shrink-0 cursor-pointer"
          >
            Reintentar
          </button>
        </div>
      }

      <!-- Loading Skeleton when filtering exclusively for Free Agents and they are loading -->
      @if (activeMarketTab === 'market' && onlyFreeAgents && isLoadingFreeAgents()) {
        <div class="space-y-4">
          <div class="flex items-center space-x-2 text-xs text-slate-500 dark:text-slate-400 py-1">
            <div class="w-3.5 h-3.5 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
            <span>Cargando agentes libres oficiales del servidor...</span>
          </div>
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            @for (sk of [1, 2, 3, 4, 5, 6]; track sk) {
              <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-5 shadow-xs flex flex-col justify-between space-y-4 animate-pulse">
                <div>
                  <div class="flex items-start justify-between">
                    <div class="space-y-2">
                      <div class="flex items-center space-x-2">
                        <div class="w-10 h-4 bg-slate-200 dark:bg-slate-800 rounded"></div>
                        <div class="w-28 h-5 bg-slate-200 dark:bg-slate-800 rounded"></div>
                      </div>
                      <div class="w-24 h-3 bg-slate-100 dark:bg-slate-800/60 rounded"></div>
                    </div>
                    <div class="w-10 h-8 bg-slate-200 dark:bg-slate-800 rounded"></div>
                  </div>
                  <div class="grid grid-cols-2 gap-2 mt-4 p-3 bg-slate-50 dark:bg-slate-950/70 rounded-xl border border-slate-200 dark:border-slate-800/80">
                    <div class="space-y-1.5">
                      <div class="w-12 h-2.5 bg-slate-200 dark:bg-slate-800 rounded"></div>
                      <div class="w-16 h-3.5 bg-slate-300 dark:bg-slate-700 rounded"></div>
                    </div>
                    <div class="space-y-1.5">
                      <div class="w-16 h-2.5 bg-slate-200 dark:bg-slate-800 rounded"></div>
                      <div class="w-16 h-3.5 bg-emerald-200 dark:bg-emerald-900/50 rounded"></div>
                    </div>
                  </div>
                </div>
                <div class="pt-2 border-t border-slate-100 dark:border-slate-800/80">
                  <div class="w-full h-9 bg-slate-200 dark:bg-slate-800 rounded-xl"></div>
                </div>
              </div>
            }
          </div>
        </div>
      } @else {
        <!-- Subtle indicator if free agents are loading in the background while viewing all market -->
        @if (activeMarketTab === 'market' && isLoadingFreeAgents() && !onlyFreeAgents) {
          <div class="flex items-center space-x-2 text-xs text-slate-500 dark:text-slate-400 py-1 px-1">
            <div class="w-3.5 h-3.5 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
            <span>Actualizando jugadores del mercado...</span>
          </div>
        }

        <!-- Market Player Cards Grid -->
        @if (currentMarketList().length > 0) {
          <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
            @for (player of currentMarketList(); track player.id) {
              <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 hover:border-slate-300 dark:hover:border-slate-700 rounded-2xl p-5 transition-all shadow-xs flex flex-col justify-between space-y-4">
                <div>
                  <div class="flex items-start justify-between gap-3">
                    <div class="flex items-center space-x-3 min-w-0">
                      <!-- Club Crest Shield -->
                      @if (getPlayerClubShortName(player); as crestCode) {
                        <img
                          [src]="getPlayerCrestUrl(player)"
                          [alt]="getPlayerClubName(player)"
                          (error)="onCrestError($event)"
                          class="w-10 h-10 object-contain shrink-0"
                          referrerpolicy="no-referrer"
                        />
                      }

                      <div class="min-w-0">
                        <div class="flex items-center space-x-2 flex-wrap gap-y-1">
                          <span class="px-2 py-0.5 rounded text-[10px] font-bold border shrink-0" [ngClass]="getPositionBadge(player.position)">
                            {{ player.position }}
                          </span>
                          <h3 class="text-base font-bold text-slate-900 dark:text-white truncate" [title]="player.name">
                            @if (canViewPlayerProfile(player)) {
                              <button type="button" (click)="openPlayerProfile(player)" class="max-w-full truncate text-left cursor-pointer hover:underline focus-visible:underline" [attr.aria-label]="'Ver ficha de ' + player.name">{{ player.name }}</button>
                            } @else {
                              {{ player.name }}
                            }
                          </h3>
                        </div>
                        <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 flex items-center space-x-1.5 flex-wrap">
                          <span>{{ player.age }} años</span>
                          <span>·</span>
                          <span class="font-semibold text-slate-700 dark:text-slate-300">
                            {{ getPlayerClubName(player) }}
                          </span>
                        </p>
                      </div>
                    </div>

                    <!-- Right Top: Overall / Averages -->
                    <div class="flex items-center space-x-2 shrink-0">
                      @if (hasCustomAverages(player)) {
                        <div class="flex items-center space-x-2 text-right bg-slate-50 dark:bg-slate-950/60 px-2.5 py-1.5 rounded-xl border border-slate-100 dark:border-slate-800">
                          <div>
                            <div class="text-base sm:text-lg font-bold text-slate-900 dark:text-white font-mono leading-none">
                              {{ formatAvg(player.averagePoints) }}
                            </div>
                            <div class="text-[9px] uppercase font-bold text-slate-400" title="Media total de puntos">Media</div>
                          </div>
                        </div>
                      } @else {
                        <div class="text-right">
                          <div class="text-2xl font-bold text-slate-900 dark:text-white font-mono leading-none">
                            {{ player.overall }}
                          </div>
                          <div class="text-[10px] uppercase font-bold text-slate-400">Media</div>
                        </div>
                      }
                    </div>
                  </div>

                  <!-- Unavailabilities Chips (e.g. INJURY, SANCTION, etc.) -->
                  @if (player.unavailabilities && player.unavailabilities.length > 0) {
                    <div class="mt-3 flex flex-wrap gap-1.5">
                      @for (unav of player.unavailabilities; track $index) {
                        <div
                          class="inline-flex items-center space-x-1.5 px-2.5 py-1 rounded-lg text-xs font-medium border shadow-2xs"
                          [ngClass]="getUnavailabilityBadgeClass(unav.type)"
                          [title]="(unav.typeLabel || getUnavailabilityTypeLabel(unav.type)) + ': ' + (unav.reasonLabel || getUnavailabilityReasonLabel(unav.reason)) + (unav.expectedEndDate ? ' (hasta ' + unav.expectedEndDate + ')' : '')"
                        >
                          <app-icon [name]="getUnavailabilityIcon(unav.type)" [size]="13" class="shrink-0" />
                          <span class="font-bold text-[10px] uppercase tracking-wide">{{ unav.typeLabel || getUnavailabilityTypeLabel(unav.type) }}:</span>
                          <span class="truncate max-w-[200px]">{{ unav.reasonLabel || getUnavailabilityReasonLabel(unav.reason) }}</span>
                        </div>
                      }
                    </div>
                  }

                  @if (player.clubId && player.clubId !== game.userClub().id) {
                    <div class="mt-3 flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400">
                      <app-icon name="shield" [size]="14" class="shrink-0" />
                      <span class="shrink-0">Club propietario:</span>
                      <span class="min-w-0 truncate font-semibold text-slate-700 dark:text-slate-300" [title]="getClubName(player.clubId)">{{ getClubName(player.clubId) }}</span>
                    </div>
                  }

                  <!-- Financial Metrics Grid -->
                  <div class="grid grid-cols-2 gap-2 mt-4 p-3 bg-slate-50 dark:bg-slate-950/70 rounded-xl border border-slate-100 dark:border-slate-800/80 text-xs">
                    <div>
                      <div class="text-[10px] text-slate-500 dark:text-slate-400">Valor Mercado</div>
                      <div class="font-bold text-slate-900 dark:text-white font-mono mt-0.5">
                        {{ player.currentMarketValue?.toFixed(1) || '0.0' }} M€
                      </div>
                    </div>

                    <div>
                      <div class="text-[10px] text-slate-500 dark:text-slate-400">{{ player.clubId ? 'Precio de venta' : 'Cláusula / Prima' }}</div>
                      <div class="font-bold text-emerald-700 dark:text-emerald-400 font-mono mt-0.5">
                        @if (player.clubId) {
                          <span>{{ player.askingPrice != null ? player.askingPrice.toFixed(1) + ' M€' : 'A negociar' }}</span>
                        } @else {
                          <span class="text-slate-500 dark:text-slate-400 text-[11px]">Sin cláusula (Libre)</span>
                        }
                      </div>
                    </div>
                  </div>
                </div>

                <!-- Action Button -->
                <div class="pt-2 border-t border-slate-100 dark:border-slate-800">
                  @if (pendingPlayerOffer(player); as pendingOffer) {
                    <div class="mb-2 rounded-xl border border-amber-200 bg-amber-50 p-3 text-xs text-amber-800 dark:border-amber-800 dark:bg-amber-950/40 dark:text-amber-300 space-y-2" role="status">
                      <div class="flex items-center gap-2 font-semibold">
                        <app-icon name="lock" [size]="14" />
                        <span>Oferta pendiente</span>
                      </div>
                      <p>Ya has presentado una oferta por este jugador.</p>

                      <button type="button" (click)="selectMarketTab('offers')" class="font-bold underline cursor-pointer block">Ver mis ofertas</button>
                    </div>
                    <button type="button" disabled class="w-full py-2.5 px-3 rounded-xl bg-amber-600 text-white font-semibold text-xs opacity-50 cursor-not-allowed">
                      Presentar Oferta
                    </button>
                  } @else if (player.marketSource === 'CLUB_LISTING') {
                    @if (player.clubId !== game.userClub().id) {
                      <button type="button" (click)="openNegotiationModal(player)"
                        class="w-full py-2.5 px-3 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white font-semibold text-xs cursor-pointer">
                        Presentar Oferta
                      </button>
                    } @else {
                    <div class="text-xs font-semibold text-emerald-700 dark:text-emerald-400">
                      Tu jugador Transferible
                    </div>
                    }
                  } @else if (player.clubId === game.userClub().id) {
                    <!-- Player owned by User -->
                    <div class="flex items-center justify-between text-xs">
                      <span class="text-emerald-700 dark:text-emerald-400 font-semibold">Tu jugador</span>
                      <button
                        type="button"
                        (click)="toggleTransferListing(player)"
                        class="px-3 py-1.5 rounded-xl border text-xs font-semibold cursor-pointer transition-all"
                        [ngClass]="player.listedForTransfer ? 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950 dark:text-rose-300 dark:border-rose-800' : 'bg-slate-100 text-slate-700 border-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700'"
                      >
                        {{ player.listedForTransfer ? 'Retirar del mercado' : 'Poner en venta' }}
                      </button>
                    </div>
                  } @else if (player.clubId === null) {
                    <!-- Free Agent -->
                    <button
                      type="button"
                      (click)="openNegotiationModal(player)"
                      class="w-full py-2.5 px-3 rounded-xl bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white font-semibold text-xs transition-all shadow-xs cursor-pointer flex items-center justify-center space-x-1.5"
                    >
                      <app-icon name="sparkles" [size]="14" />
                      <span>Presentar Oferta</span>
                    </button>
                  } @else {
                    <!-- Opponent Player with Buyout Clause / Contract -->
                    <button
                      type="button"
                      (click)="openNegotiationModal(player)"
                      class="w-full py-2.5 px-3 rounded-xl bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-900 dark:text-white font-semibold text-xs transition-all cursor-pointer flex items-center justify-center space-x-1"
                    >
                      <app-icon name="file-text" [size]="14" />
                      <span>Ofertar</span>
                    </button>
                  }
                </div>
              </div>
            }
          </div>
        } @else {
          <!-- Empty State -->
          <div class="text-center py-12 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-8 shadow-xs">
            <app-icon name="shield" [size]="40" class="mx-auto text-slate-300 dark:text-slate-600" />
            <h3 class="text-sm font-bold text-slate-900 dark:text-white mt-3">No se encontraron futbolistas</h3>
            <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 max-w-sm mx-auto">
              Prueba a cambiar los filtros de posición o de procedencia para ver más jugadores disponibles.
            </p>
          </div>
        }
      }
      } @else if (activeMarketTab === 'my_sales') {
        <!-- ========================================== -->
        <!-- SUBTAB: MIS VENTAS (OFERTAS RECIBIDAS)     -->
        <!-- ========================================== -->
        <div class="space-y-6">
          <!-- Summary Header -->
          <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3 p-4 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs">
            <div class="space-y-0.5">
              <div class="flex items-center gap-2">
                <h2 class="text-sm font-bold text-slate-900 dark:text-white">Gestión de Transferibles y Ofertas Recibidas</h2>
                @if (receivedTransfersLoading()) {
                  <div class="w-3.5 h-3.5 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
                }
              </div>
              <p class="text-xs text-slate-500 dark:text-slate-400">
                Consulta y gestiona las ofertas presentadas tras el cierre diario antes de la fecha límite de cada ronda.
              </p>
            </div>
            <div class="flex items-center gap-2 self-start sm:self-auto shrink-0">
              <button
                type="button"
                (click)="loadReceivedOffers(true)"
                [disabled]="receivedTransfersLoading()"
                class="inline-flex items-center space-x-1.5 px-3 py-1.5 rounded-xl border border-slate-200 dark:border-slate-700 bg-slate-50 hover:bg-slate-100 dark:bg-slate-800 dark:hover:bg-slate-700 text-xs font-semibold text-slate-700 dark:text-slate-200 cursor-pointer transition-all disabled:opacity-50"
                title="Recargar ofertas recibidas del servidor"
              >
                <app-icon name="refresh-cw" [size]="13" [class.animate-spin]="receivedTransfersLoading()" />
                <span>Actualizar</span>
              </button>
            </div>
          </div>

          <!-- Alert Banners -->
          <!-- 1. HTTP 409 Conflict Banner (Criterio 8) -->
          @if (conflictErrorMessage(); as conflictMsg) {
            <div class="p-4 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-xs text-amber-900 dark:text-amber-200 flex items-start justify-between gap-3 shadow-xs">
              <div class="flex items-start space-x-2.5">
                <app-icon name="alert-triangle" [size]="18" class="text-amber-600 dark:text-amber-400 shrink-0 mt-0.5" />
                <div>
                  <div class="font-bold">Conflicto en la decisión</div>
                  <div class="mt-0.5 text-xs">{{ conflictMsg }}</div>
                </div>
              </div>
              <button
                type="button"
                (click)="conflictErrorMessage.set(null)"
                class="text-amber-700 hover:text-amber-900 dark:text-amber-400 dark:hover:text-amber-200 p-1 rounded-md cursor-pointer"
                title="Cerrar aviso"
              >
                <app-icon name="x" [size]="14" />
              </button>
            </div>
          }

          <!-- 2. Round Sync Failure Banner (Criterios 5 y 8) -->
          @if (roundSyncErrorMessage(); as syncMsg) {
            <div class="p-4 rounded-xl bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-800/60 text-xs text-rose-900 dark:text-rose-200 flex items-start justify-between gap-3 shadow-xs">
              <div class="flex items-start space-x-2.5">
                <app-icon name="alert-circle" [size]="18" class="text-rose-600 dark:text-rose-400 shrink-0 mt-0.5" />
                <div>
                  <div class="font-bold">Actualización de ronda requerida</div>
                  <div class="mt-0.5 text-xs">{{ syncMsg }}</div>
                </div>
              </div>
              <button
                type="button"
                (click)="loadReceivedOffers(true)"
                class="px-3 py-1.5 bg-rose-600 hover:bg-rose-700 text-white rounded-lg text-xs font-semibold shrink-0 cursor-pointer shadow-xs inline-flex items-center space-x-1"
              >
                <app-icon name="refresh-cw" [size]="12" />
                <span>Reintentar actualización</span>
              </button>
            </div>
          }

          <!-- 3. General Decision Error Banner (Criterio 9) -->
          @if (decisionErrorMessage(); as decErr) {
            <div class="p-4 rounded-xl bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-800/60 text-xs text-rose-900 dark:text-rose-200 flex items-start justify-between gap-3 shadow-xs">
              <div class="flex items-start space-x-2.5">
                <app-icon name="alert-circle" [size]="18" class="text-rose-600 dark:text-rose-400 shrink-0 mt-0.5" />
                <div class="mt-0.5 text-xs">{{ decErr }}</div>
              </div>
              <button
                type="button"
                (click)="decisionErrorMessage.set(null)"
                class="text-rose-700 hover:text-rose-900 dark:text-rose-400 p-1 cursor-pointer"
                title="Cerrar aviso"
              >
                <app-icon name="x" [size]="14" />
              </button>
            </div>
          }

          <!-- 4. Success Toast/Banner (Criterio 6) -->
          @if (decisionSuccessMessage(); as successMsg) {
            <div class="p-3.5 rounded-xl bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-800/60 text-xs text-emerald-900 dark:text-emerald-200 flex items-center justify-between gap-3 shadow-xs">
              <div class="flex items-center space-x-2">
                <app-icon name="check-circle" [size]="16" class="text-emerald-600 dark:text-emerald-400 shrink-0" />
                <span class="font-semibold">{{ successMsg }}</span>
              </div>
              <button
                type="button"
                (click)="decisionSuccessMessage.set(null)"
                class="text-emerald-700 hover:text-emerald-900 dark:text-emerald-400 p-1 cursor-pointer"
                title="Cerrar aviso"
              >
                <app-icon name="x" [size]="14" />
              </button>
            </div>
          }

          <!-- Loading Skeleton (Criterio 1) -->
          @if (receivedTransfersLoading() && mySalesPlayerGroups().length === 0) {
            <div class="space-y-4">
              <div class="flex items-center space-x-2 text-xs text-slate-500 dark:text-slate-400 py-1">
                <div class="w-3.5 h-3.5 border-2 border-emerald-600 border-t-transparent rounded-full animate-spin"></div>
                <span>Cargando ofertas recibidas del club...</span>
              </div>
              @for (sk of [1, 2, 3]; track sk) {
                <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-5 shadow-xs animate-pulse space-y-4">
                  <div class="flex items-center justify-between">
                    <div class="flex items-center space-x-3">
                      <div class="w-10 h-6 bg-slate-200 dark:bg-slate-800 rounded"></div>
                      <div class="w-32 h-5 bg-slate-200 dark:bg-slate-800 rounded"></div>
                    </div>
                    <div class="w-24 h-6 bg-slate-200 dark:bg-slate-800 rounded"></div>
                  </div>
                  <div class="h-20 bg-slate-50 dark:bg-slate-800/40 rounded-xl"></div>
                </div>
              }
            </div>
          } @else if (receivedTransfersError() && mySalesPlayerGroups().length === 0) {
            <!-- Error State with Retry Button (Criterio 1) -->
            <div class="p-8 text-center bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs space-y-3">
              <app-icon name="alert-triangle" [size]="36" class="mx-auto text-amber-500" />
              <h3 class="text-sm font-bold text-slate-900 dark:text-white">No se pudieron cargar las ofertas recibidas</h3>
              <p class="text-xs text-slate-500 dark:text-slate-400 max-w-sm mx-auto">
                {{ receivedTransfersError() }}
              </p>
              <button
                type="button"
                (click)="loadReceivedOffers(true)"
                class="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-xs font-semibold cursor-pointer shadow-xs inline-flex items-center space-x-1.5"
              >
                <app-icon name="refresh-cw" [size]="14" />
                <span>Reintentar consulta</span>
              </button>
            </div>
          } @else if (mySalesPlayerGroups().length === 0) {
            <!-- Empty State (Criterio 1) -->
            <div class="p-10 text-center bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs space-y-3">
              <div class="w-14 h-14 mx-auto rounded-2xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400">
                <app-icon name="coins" [size]="28" />
              </div>
              <h3 class="text-sm font-bold text-slate-900 dark:text-white">No tienes futbolistas en venta ni ofertas recibidas</h3>
              <p class="text-xs text-slate-500 dark:text-slate-400 max-w-md mx-auto">
                Para recibir ofertas de otros clubes o del juego, pon a la venta futbolistas de tu plantilla desde la sección de Plantilla.
              </p>
              <div class="pt-2">
                <button
                  type="button"
                  (click)="selectMarketTab('market')"
                  class="px-4 py-2 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl text-xs font-semibold cursor-pointer shadow-xs inline-flex items-center space-x-1.5"
                >
                  <app-icon name="store" [size]="14" />
                  <span>Explorar Mercado</span>
                </button>
              </div>
            </div>
          } @else {
            <!-- Main Content: Players on Sale with Received Offers Grouped by Round (Criterio 1) -->
            <div class="space-y-6">
              @for (group of mySalesPlayerGroups(); track group.playerInstanceId) {
                <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-xs overflow-hidden">
                  <!-- Player Header (Criterio 2) -->
                  <div class="p-4 sm:p-5 bg-slate-50/70 dark:bg-slate-950/50 border-b border-slate-100 dark:border-slate-800 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-3">
                    <div class="flex items-center gap-3">
                      @if (group.crestUrl) {
                        <img [src]="group.crestUrl" [alt]="group.realClubName || ''"
                          (error)="onCrestError($event)" class="w-10 h-10 object-contain shrink-0"
                          referrerpolicy="no-referrer" />
                      }
                      <span class="px-2.5 py-1 rounded-lg text-xs font-bold border" [ngClass]="group.positionClass">
                        {{ group.position }}
                      </span>
                      <div>
                        <button
                          type="button"
                          (click)="openSalesPlayerProfile(group)"
                          class="text-sm sm:text-base font-bold text-slate-900 dark:text-white hover:text-emerald-600 dark:hover:text-emerald-400 text-left transition-colors cursor-pointer inline-flex items-center gap-1.5"
                          title="Ver ficha del futbolista"
                        >
                          <span>{{ group.name }}</span>
                          <app-icon name="external-link" [size]="13" class="opacity-60" />
                        </button>
                        @if (group.realClubName) {
                          <p class="text-xs text-slate-500 dark:text-slate-400 mt-1">{{ group.realClubName }}</p>
                        }
                        <div class="flex items-center gap-2 text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">
                          <span>Valor: <strong class="text-slate-700 dark:text-slate-200 font-mono">{{ group.currentMarketValue.toFixed(1) }} M€</strong></span>
                          @if (group.askingPrice) {
                            <span>·</span>
                            <span>Precio fijado: <strong class="text-emerald-600 dark:text-emerald-400 font-mono">{{ group.askingPrice.toFixed(1) }} M€</strong></span>
                          }
                        </div>
                      </div>
                    </div>

                    <!-- Right actions / badges on player -->
                    <div class="flex flex-wrap items-center gap-2 self-end sm:self-auto">
                      @if (group.pendingDecisionsCount > 0) {
                        <span class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300 border border-amber-200 dark:border-amber-800">
                          {{ group.pendingDecisionsCount }} {{ group.pendingDecisionsCount === 1 ? 'decisión pendiente' : 'decisiones pendientes' }}
                        </span>
                      }
                      @if (group.hasAcceptedOffer) {
                        <span class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300 border border-emerald-200 dark:border-emerald-800">
                          Oferta seleccionada
                        </span>
                      }
                      @if (group.player) {
                        <button
                          type="button"
                          (click)="toggleTransferListing(group.player)"
                          class="px-2.5 py-1 rounded-lg border text-xs font-semibold cursor-pointer transition-all"
                          [ngClass]="group.listedForTransfer ? 'bg-rose-50 text-rose-700 border-rose-200 hover:bg-rose-100 dark:bg-rose-950/60 dark:text-rose-300 dark:border-rose-800' : 'bg-slate-100 text-slate-700 border-slate-200 hover:bg-slate-200 dark:bg-slate-800 dark:text-slate-300 dark:border-slate-700'"
                        >
                          {{ group.listedForTransfer ? 'Retirar de venta' : 'Poner en venta' }}
                        </button>
                      }
                    </div>
                  </div>

                  <!-- Offers Body for this Player -->
                  <div class="p-4 sm:p-5 space-y-4">
                    @if (group.rounds.length === 0) {
                      <div class="p-4 rounded-xl bg-slate-50 dark:bg-slate-950/30 border border-dashed border-slate-200 dark:border-slate-800 text-center text-xs text-slate-500 dark:text-slate-400">
                        <app-icon name="clock" [size]="16" class="mx-auto text-slate-400 mb-1" />
                        <span>Sin ofertas recibidas en este momento. Las ofertas de otros clubes y del juego se presentarán tras el cierre diario.</span>
                      </div>
                    } @else {
                      @let offerDates = mySalesOfferSections(group);
                      @for (day of offerDates.today; track day.key) {
                        <ng-container *ngTemplateOutlet="salesOfferDay; context: { $implicit: day }" />
                      }
                      @if (offerDates.otherDays.length > 0) {
                        <details class="group/history rounded-xl border border-slate-200 dark:border-slate-800 overflow-hidden">
                          <summary class="flex items-center justify-between gap-2 px-3.5 py-3 cursor-pointer list-none bg-slate-100/80 dark:bg-slate-800/60 text-xs font-bold text-slate-800 dark:text-slate-200 focus-visible:outline-2 focus-visible:outline-emerald-600 [&::-webkit-details-marker]:hidden">
                            <span>Ofertas de otros días ({{ offerDates.otherOffersCount }})</span>
                            <app-icon name="chevron-down" [size]="16" class="transition-transform group-open/history:rotate-180" />
                          </summary>
                          <div class="p-3 space-y-3">
                            @for (day of offerDates.otherDays; track day.key) {
                              <ng-container *ngTemplateOutlet="salesOfferDay; context: { $implicit: day }" />
                            }
                          </div>
                        </details>
                      }
                      <ng-template #salesOfferDay let-day>
                        <div class="rounded-xl border border-slate-200/90 dark:border-slate-800 overflow-hidden">
                          <!-- Date header -->
                          <div class="px-3.5 py-2 bg-slate-100/80 dark:bg-slate-800/60 border-b border-slate-200 dark:border-slate-700/80 flex items-center justify-between">
                            <div class="flex items-center space-x-2">
                              <app-icon name="layers" [size]="14" class="text-slate-500 dark:text-slate-400" />
                              <span class="text-xs font-bold text-slate-800 dark:text-slate-200">
                                {{ day.label }}
                              </span>
                              <span class="text-[11px] text-slate-500 dark:text-slate-400">
                                ({{ day.items.length }} {{ day.items.length === 1 ? 'oferta recibida' : 'ofertas recibidas' }})
                              </span>
                            </div>
                            @if (day.failedRoundIds.length > 0) {
                              <button
                                type="button"
                                (click)="retryRoundSync(day.failedRoundIds)"
                                class="text-[11px] font-bold text-rose-600 hover:text-rose-700 dark:text-rose-400 cursor-pointer flex items-center space-x-1"
                              >
                                <app-icon name="refresh-cw" [size]="12" />
                                <span>Reintentar actualización</span>
                              </button>
                            }
                          </div>

                          <!-- Offers for this date -->
                          <div class="divide-y divide-slate-100 dark:divide-slate-800/80">
                            @for (offer of day.items; track offer.id) {
                              <div class="p-3.5 sm:p-4 hover:bg-slate-50/50 dark:hover:bg-slate-800/30 transition-colors flex flex-col md:flex-row md:items-center md:justify-between gap-3">
                                <!-- Left: Buyer, Amount, Badges -->
                                <div class="space-y-1.5 flex-1 min-w-0">
                                  <div class="flex flex-wrap items-center gap-2.5">
                                    <!-- Buyer club name -->
                                    <div class="flex items-center space-x-2">                                      
                                      <span class="text-xs font-bold text-slate-900 dark:text-white">
                                        {{ getBuyerClubName(offer) }}
                                      </span>
                                    </div>

                                    <!-- Transfer Amount in Euros (Criterio 2) -->
                                    <div class="text-sm sm:text-base font-extrabold text-emerald-600 dark:text-emerald-400 font-mono">
                                      {{ formatTransferEuros(offer.terms?.transferAmount) }}
                                    </div>
                                  </div>

                                  <!-- Status & Decision Badges (Criterio 2 & 6 & 7) -->
                                  <div class="flex flex-wrap items-center gap-1.5 text-xs">
                                    <!-- Vendedor Decision Badge (Criterio 6) -->
                                    @if (offer.clubDecision === 'ACCEPTED') {
                                      <span class="inline-flex items-center space-x-1 px-2.5 py-0.5 rounded-full text-[11px] font-bold bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-700">
                                        <app-icon name="check" [size]="12" />
                                        <span>Seleccionada para ejecución al cierre</span>
                                      </span>
                                    } @else if (offer.clubDecision === 'REJECTED') {
                                      <span class="inline-flex items-center space-x-1 px-2 py-0.5 rounded-full text-[11px] font-semibold bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400 border border-slate-300 dark:border-slate-700">
                                        <app-icon name="x" [size]="11" />
                                        <span>Rechazada</span>
                                      </span>
                                    } @else {
                                      <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-semibold bg-amber-50 text-amber-700 dark:bg-amber-950/60 dark:text-amber-300 border border-amber-200 dark:border-amber-800">
                                        Pendiente de decisión
                                      </span>
                                    }

                                    <!-- Operation Status (Criterio 7) -->
                                    @if (offer.status === 'COMPLETED') {
                                      <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-bold bg-emerald-600 text-white shadow-2xs">
                                        Venta completada
                                      </span>
                                    } @else if (offer.status !== 'AWAITING_SELLER') {
                                      <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[11px] font-medium bg-slate-100 text-slate-600 dark:bg-slate-800 dark:text-slate-400">
                                        {{ getOperationStatusLabel(offer.status) }}
                                      </span>
                                    }

                                    <!-- Deadline Countdown Badge (Criterio 2 & 3) -->
                                    @if (offer.decisionDeadline) {
                                      @let badge = getDeadlineRemainingBadge(offer.decisionDeadline);
                                      <span
                                        class="inline-flex items-center space-x-1 px-2 py-0.5 rounded-md text-[11px] font-medium border"
                                        [ngClass]="badge.isExpired ? 'bg-slate-100 text-slate-500 border-slate-200 dark:bg-slate-800 dark:text-slate-400 dark:border-slate-700' : (badge.isUrgent ? 'bg-rose-50 text-rose-700 border-rose-200 dark:bg-rose-950 dark:text-rose-300 dark:border-rose-800 font-bold' : 'bg-slate-50 text-slate-600 border-slate-200 dark:bg-slate-800/80 dark:text-slate-300 dark:border-slate-700')"
                                      >
                                        <app-icon name="clock" [size]="11" />
                                        <span>Fecha límite: {{ formatDecisionDeadline(offer.decisionDeadline) }} · {{ badge.text }}</span>
                                      </span>
                                    }
                                  </div>
                                </div>

                                <!-- Right: Action Buttons (Aceptar / Rechazar) (Criterios 3 y 4 y 7) -->
                                <div class="flex items-center gap-2 self-end md:self-center shrink-0">
                                  @if (offer.status === 'COMPLETED') {
                                    <div class="text-[11px] font-bold text-emerald-600 dark:text-emerald-400">
                                      Venta completada
                                    </div>
                                  } @else if (offer.sellerClubId === game.userClub()?.id && offer.status === 'AWAITING_SELLER' && offer.type !== 'RELEASE_CLAUSE') {
                                    <!-- Botón Aceptar -->
                                    <button
                                      type="button"
                                      (click)="handleSellerDecision(offer, true)"
                                      [disabled]="!game.canAction('sellPlayer') || (!isDecisionAvailable(offer) || isDecisionButtonBlocked(offer) || offer.clubDecision === 'ACCEPTED')"
                                      class="px-3.5 py-1.5 rounded-xl font-semibold text-xs cursor-pointer transition-all inline-flex items-center space-x-1 shadow-xs disabled:opacity-50 disabled:cursor-not-allowed"
                                      [ngClass]="offer.clubDecision === 'ACCEPTED' ? 'bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300 border border-emerald-300 dark:border-emerald-700' : 'bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white'"
                                      title="Aceptar esta oferta para ejecutarla al cierre"
                                    >
                                      @if (processingOfferId() === offer.id && processingAction() === 'accept') {
                                        <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                                        <span>Guardando...</span>
                                      } @else {
                                        <app-icon name="check" [size]="14" />
                                        <span>{{ offer.clubDecision === 'ACCEPTED' ? 'Seleccionada' : 'Aceptar' }}</span>
                                      }
                                    </button>

                                    <!-- Botón Rechazar -->
                                    <button
                                      type="button"
                                      (click)="handleSellerDecision(offer, false)"
                                      [disabled]="!game.canAction('sellPlayer') || (!isDecisionAvailable(offer) || isDecisionButtonBlocked(offer) || offer.clubDecision === 'REJECTED')"
                                      class="px-3 py-1.5 rounded-xl font-semibold text-xs cursor-pointer transition-all inline-flex items-center space-x-1 border disabled:opacity-50 disabled:cursor-not-allowed"
                                      [ngClass]="offer.clubDecision === 'REJECTED' ? 'bg-slate-100 text-slate-500 border-slate-200 dark:bg-slate-800 dark:text-slate-500 dark:border-slate-700' : 'bg-white hover:bg-rose-50 text-rose-700 border-rose-200 hover:border-rose-300 dark:bg-slate-900 dark:hover:bg-rose-950/40 dark:text-rose-400 dark:border-rose-900/60'"
                                      title="Rechazar esta oferta"
                                    >
                                      @if (processingOfferId() === offer.id && processingAction() === 'reject') {
                                        <div class="w-3.5 h-3.5 border-2 border-rose-600 border-t-transparent rounded-full animate-spin"></div>
                                        <span>Rechazando...</span>
                                      } @else {
                                        <app-icon name="x" [size]="14" />
                                        <span>{{ offer.clubDecision === 'REJECTED' ? 'Rechazada' : 'Rechazar' }}</span>
                                      }
                                    </button>

                                    @if (isDecisionExpired(offer.decisionDeadline)) {
                                      <span class="text-[11px] text-slate-400 dark:text-slate-500 italic ml-1">
                                        Plazo cerrado
                                      </span>
                                    }
                                  } @else {
                                    <div class="text-[11px] text-slate-400 dark:text-slate-500 italic">
                                      {{ getOperationStatusLabel(offer.status) }}
                                    </div>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        </div>
                      </ng-template>
                    }
                  </div>
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- ========================================== -->
  <!-- TAB 2: ENTRENADORES (COACHES)              -->
  <!-- ========================================== -->
  @if (activeTab === 'coaches') {
    <div class="space-y-6">
      <!-- Sub-Navigation Bar: Mercado Diario vs Mi Entrenador vs Mis Ofertas -->
      <div class="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
        <div class="flex bg-slate-100 dark:bg-slate-900 p-1 rounded-xl border border-slate-200 dark:border-slate-800 space-x-1 overflow-x-auto shrink-0">
          <!-- Subtab 1: Mercado Diario -->
          <button
            type="button"
            (click)="setCoachesSubTab('market')"
            id="coaches-subtab-market"
            class="flex items-center space-x-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap shrink-0"
            [ngClass]="coachesSubTab === 'market' ? 'bg-emerald-600 text-white shadow-xs' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800'"
          >
            <app-icon name="store" [size]="15" />
            <span>{{ game.t('coaches.tab_market') }}</span>
            @if (game.coaches.market()?.listings?.length; as count) {
              <span class="text-[10px] px-1.5 py-0.5 rounded-md font-mono font-bold" [ngClass]="coachesSubTab === 'market' ? 'bg-emerald-700 text-white' : 'bg-slate-200 dark:bg-slate-800 text-slate-700 dark:text-slate-300'">
                {{ count }}
              </span>
            }
          </button>

          <!-- Subtab 3: Mis Ofertas -->
          <button
            type="button"
            (click)="setCoachesSubTab('offers')"
            id="coaches-subtab-offers"
            class="flex items-center space-x-1.5 px-3.5 py-2 rounded-lg text-xs font-semibold transition-all cursor-pointer whitespace-nowrap shrink-0"
            [ngClass]="coachesSubTab === 'offers' ? 'bg-emerald-600 text-white shadow-xs' : 'text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800'"
          >
            <app-icon name="file-text" [size]="15" />
            <span>{{ game.t('coaches.tab_offers') }}</span>
            @if (game.coaches.pendingOffers().length > 0) {
              <span class="text-[10px] px-1.5 py-0.5 rounded-md font-mono font-bold" [ngClass]="coachesSubTab === 'offers' ? 'bg-emerald-700 text-white' : 'bg-amber-100 dark:bg-amber-950 text-amber-800 dark:text-amber-300'">
                {{ game.coaches.pendingOffers().length }}
              </span>
            }
          </button>
        </div>
        @if (coachesSubTab === 'offers') {
          <div aria-label="Filtrar ofertas de entrenadores" class="flex flex-nowrap items-center gap-1 sm:gap-2 overflow-x-auto min-w-0 max-w-full">
            <button type="button" (click)="toggleCoachOfferFilter('active')"
              [attr.aria-pressed]="coachOfferListFilter !== 'history'"
              class="px-2 sm:px-2.5 py-2 rounded-xl text-xs font-semibold whitespace-nowrap shrink-0 transition-colors cursor-pointer"
              [ngClass]="coachOfferListFilter !== 'history' ? 'bg-emerald-600 text-white shadow-xs' : 'bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-900 dark:hover:text-white'">Activas</button>
            <button type="button" (click)="toggleCoachOfferFilter('history')"
              [attr.aria-pressed]="coachOfferListFilter !== 'active'"
              class="px-2 sm:px-2.5 py-2 rounded-xl text-xs font-semibold whitespace-nowrap shrink-0 transition-colors cursor-pointer"
              [ngClass]="coachOfferListFilter !== 'active' ? 'bg-emerald-600 text-white shadow-xs' : 'bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-900 dark:hover:text-white'">Históricas</button>
            @for (status of ['WON', 'LOST', 'CANCELLED']; track status) {
              <button type="button" (click)="setCoachHistoryFilter(status)"
                [attr.aria-pressed]="coachOfferListFilter !== 'active' && coachHistoryFilter === status"
                class="px-2 sm:px-2.5 py-2 rounded-xl text-xs font-semibold whitespace-nowrap shrink-0 transition-colors cursor-pointer"
                [ngClass]="coachOfferListFilter !== 'active' && coachHistoryFilter === status ? 'bg-emerald-600 text-white shadow-xs' : 'bg-white dark:bg-slate-950 border border-slate-200 dark:border-slate-800 text-slate-600 hover:bg-slate-100 dark:text-slate-400 dark:hover:bg-slate-900 dark:hover:text-white'">
                {{ status === 'WON' ? 'Ganadas' : status === 'LOST' ? 'Perdidas' : 'Canceladas' }}
              </button>
            }
          </div>
        }
      </div>

      <!-- Error Banner if any -->
      @if (game.coaches.marketError(); as err) {
        <div class="p-4 bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-900/60 rounded-xl text-rose-800 dark:text-rose-300 text-xs flex items-center space-x-2">
          <app-icon name="alert-circle" [size]="16" class="shrink-0" />
          <span>{{ err }}</span>
        </div>
      }

      @if (game.coaches.offersError(); as err) {
        <div role="alert" class="p-4 rounded-xl border border-rose-300 bg-rose-50 text-rose-800 text-xs">
          {{ err }} {{ game.t('coaches.offers_unverified') }}
          <button type="button" (click)="loadCoachesData(true)" [disabled]="game.coaches.isLoadingOffers()" class="underline font-bold ml-2">{{ game.t('coaches.retry') }}</button>
        </div>
      } @else if (!game.coaches.offersLoaded() || game.coaches.isLoadingOffers()) {
        <p role="status" class="p-4 text-xs text-slate-500">{{ game.t('coaches.checking_offers') }}</p>
      }
      @if (game.coaches.retryOffer()) {
        <div role="alert" class="p-4 rounded-xl border border-amber-300 bg-amber-50 text-amber-900 text-xs space-y-2">
          <p>{{ game.t('coaches.uncertain_offer') }}</p>
          <button type="button" (click)="retryCoachOffer()" [disabled]="!game.canAction('bidCoach') || (game.coaches.isSubmittingOffer())" class="underline font-bold disabled:opacity-50">{{ game.t('coaches.retry') }}</button>
        </div>
      }      

      <!-- ============================================== -->
      <!-- SUBTAB 1: MERCADO DIARIO DE ENTRENADORES       -->
      <!-- ============================================== -->
      @if (coachesSubTab === 'market') {
        <!-- Coach Cards (up to 3) -->
        @if (game.coaches.market()?.listings; as listings) {
          @if (listings.length > 0) {
            <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
              @for (coach of listings; track coach.id) {
                @let existingOffer = game.coaches.pendingOffersByCoachId()[coach.id];
                <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-5 shadow-xs hover:shadow-md transition-all flex flex-col justify-between">
                  <div>
                    <!-- Coach Header: Image & Name -->
                    <div class="flex items-center space-x-3.5 mb-4">
                      <div class="relative w-14 h-14 rounded-2xl overflow-hidden shrink-0">
                        @if (coach.realClub?.shortName) {
                          <img
                            [src]="getCoachCrestUrl(coach)"
                            [alt]="coach.realClub!.name"
                            (error)="onCrestError($event)"
                            class="w-full h-full object-contain"
                            referrerpolicy="no-referrer"
                          />
                        } @else {
                          <div class="w-full h-full flex items-center justify-center text-slate-400">
                            <app-icon name="user" [size]="28" />
                          </div>
                        }
                      </div>

                      <div class="min-w-0 flex-1">
                        <div class="flex items-center justify-between">
                          <span class="text-[10px] font-bold uppercase tracking-wider text-slate-400">Técnico Libre</span>
                          @if (existingOffer) {
                            <span class="px-2 py-0.5 rounded-full text-[10px] font-bold bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300 border border-amber-300 dark:border-amber-700">
                              Oferta Activa
                            </span>
                          }
                        </div>
                        <h4 class="text-base font-bold text-slate-900 dark:text-white truncate" [title]="coach.name">
                          {{ coach.name }}
                        </h4>
                      </div>
                    </div>

                    <!-- Tactical Modifiers Grid (Direct Percentages) -->
                    <div class="grid grid-cols-3 gap-2 p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 text-center mb-4">
                      <div>
                        <div class="text-[10px] uppercase font-bold text-slate-400">{{ game.t('coaches.attack') }}</div>
                        <div class="text-sm font-bold text-emerald-600 dark:text-emerald-400 font-mono">
                          +{{ coach.attack }} %
                        </div>
                      </div>
                      <div class="border-x border-slate-200 dark:border-slate-800">
                        <div class="text-[10px] uppercase font-bold text-slate-400">{{ game.t('coaches.midfield') }}</div>
                        <div class="text-sm font-bold text-blue-600 dark:text-blue-400 font-mono">
                          +{{ coach.midfield }} %
                        </div>
                      </div>
                      <div>
                        <div class="text-[10px] uppercase font-bold text-slate-400">{{ game.t('coaches.defense') }}</div>
                        <div class="text-sm font-bold text-amber-600 dark:text-amber-400 font-mono">
                          +{{ coach.defense }} %
                        </div>
                      </div>
                    </div>

                    <!-- Existing Offer Banner if present -->
                    @if (existingOffer) {
                      <div class="mb-4 p-2.5 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-[11px] space-y-1">
                        <div class="flex items-center justify-between font-bold text-amber-900 dark:text-amber-200">
                          <span>Tu oferta registrada:</span>
                        </div>
                        <div class="text-slate-600 dark:text-slate-400 flex justify-between">
                          <span>Prima: {{ existingOffer.signing_bonus | number:'1.0-0' }} €</span>
                          <span>Salario: {{ existingOffer.annual_salary | number:'1.0-0' }} €</span>
                        </div>
                      </div>
                    }
                  </div>

                  <!-- Action Buttons -->
                  <div class="pt-2">
                    <button
                      type="button"
                      [id]="'btn-coach-offer-' + coach.id"
                      (click)="openCoachOfferModal(coach)"
                      [disabled]="!game.canAction('bidCoach') || (!canPlaceCoachOffer())"
                      class="w-full py-2.5 px-4 rounded-xl text-xs font-semibold flex items-center justify-center space-x-1.5 transition-all cursor-pointer shadow-xs active:scale-98 disabled:opacity-50 disabled:cursor-not-allowed"
                      [ngClass]="existingOffer ? 'bg-amber-600 hover:bg-amber-700 text-white' : 'bg-emerald-600 hover:bg-emerald-700 text-white'"
                    >
                      <app-icon name="send" [size]="14" />
                      <span>{{ game.t('coaches.submit_offer') }}</span>
                    </button>
                  </div>
                </div>
              }
            </div>
          } @else {
            <!-- Empty State for Market (No inventar disponibilidad) -->
            <div class="text-center py-16 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-8 shadow-xs">
              <div class="w-14 h-14 mx-auto rounded-2xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400 mb-3">
                <app-icon name="user-x" [size]="28" />
              </div>
              <h3 class="text-base font-bold text-slate-900 dark:text-white">{{ game.t('coaches.empty_market') }}</h3>
              <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 max-w-md mx-auto">
                {{ game.t('coaches.empty_market_desc') }}
              </p>
            </div>
          }
        }
      }

      <!-- ============================================== -->
      <!-- SUBTAB 3: OFERTAS PROPIAS DE ENTRENADORES       -->
      <!-- ============================================== -->
      @if (coachesSubTab === 'offers') {
        <div class="space-y-4">

          @if (groupedCoachOffers().length > 0) {
            <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
              @for (group of groupedCoachOffers(); track group.key) {
                <div class="col-span-full flex items-center justify-between pt-1">
                  <h3 class="flex items-center gap-2 text-xs font-bold text-slate-700 dark:text-slate-300">
                    <app-icon name="calendar" [size]="14" class="text-indigo-500 dark:text-indigo-400" />
                    <span>{{ group.label }}</span>
                  </h3>
                  <span class="text-[11px] font-mono text-slate-400">{{ group.items.length }} {{ group.items.length === 1 ? 'oferta' : 'ofertas' }}</span>
                </div>
                @for (offer of group.items; track offer.id) {
                @let statusBadge = getCoachOfferStatusBadge(offer.status);
                @let coachName = coachOfferName(offer);
                @let coachImg = coachOfferImage(offer);

                <div class="bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-5 shadow-xs flex flex-col space-y-4">
                  <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                    <div class="flex items-center space-x-3 min-w-0 w-full sm:flex-1">
                      <div class="w-10 h-10 overflow-hidden shrink-0">
                        @if (coachOfferCrest(offer); as crest) {
                          <img [src]="crest" [alt]="coachOfferClub(offer)?.name || ''" (error)="onCrestError($event)" class="w-full h-full object-contain" referrerpolicy="no-referrer" />
                        } @else if (coachImg) {
                          <img [src]="coachImg" [alt]="coachName" (error)="onCoachImageError($event)" class="w-full h-full object-cover" referrerpolicy="no-referrer" />
                        } @else {
                          <div class="w-full h-full flex items-center justify-center text-slate-400">
                            <app-icon name="user" [size]="18" />
                          </div>
                        }
                      </div>
                      <div class="min-w-0 flex-1">
                        <h4 class="font-bold text-base text-slate-900 dark:text-white whitespace-normal break-words">{{ coachName }}</h4>
                        @if (coachOfferClub(offer); as club) {
                          <p class="mt-1 text-xs font-semibold text-slate-700 dark:text-slate-300">{{ club.name }}</p>
                        }
                        <div class="mt-0.5 text-[11px] text-slate-500 dark:text-slate-400">
                          Enviada: <strong>{{ formatHistoryDate(offer.submitted_at) }}</strong>
                        </div>
                      </div>
                    </div>

                    <!-- Status Badge -->
                    <div class="shrink-0 text-right self-end order-first sm:order-last sm:self-start">
                      <span class="px-2.5 py-1 rounded-lg text-[11px] font-bold border inline-flex items-center space-x-1" [ngClass]="statusBadge.class">
                        <app-icon [name]="statusBadge.icon" [size]="12" />
                        <span>{{ statusBadge.label }}</span>
                      </span>
                    </div>
                  </div>

                  <div class="p-2.5 sm:p-3.5 bg-slate-50 dark:bg-slate-950/80 rounded-xl border border-slate-200 dark:border-slate-800 space-y-2.5">
                    <div class="text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400">Términos de la oferta presentada</div>
                    <div class="grid grid-cols-3 gap-2 text-xs">
                      <div>
                        <div class="text-[10px] text-slate-500 dark:text-slate-400">Prima</div>
                        <div class="font-bold font-mono text-xs sm:text-sm whitespace-nowrap text-slate-900 dark:text-white">{{ (offer.signing_bonus / 1000000).toFixed(2) }} M€</div>
                      </div>
                      <div>
                        <div class="text-[10px] text-slate-500 dark:text-slate-400">Ficha anual</div>
                        <div class="font-bold font-mono text-xs sm:text-sm whitespace-nowrap text-slate-900 dark:text-white">{{ (offer.annual_salary / 1000000).toFixed(2) }} M€</div>
                      </div>
                      <div>
                        <div class="text-[10px] text-slate-500 dark:text-slate-400">Cláusula</div>
                        <div class="font-bold font-mono text-xs sm:text-sm whitespace-nowrap text-slate-900 dark:text-white">{{ (offer.release_clause / 1000000).toFixed(2) }} M€</div>
                      </div>
                    </div>
                  </div>

                  <!-- Actions for PENDING offer -->
                  @if (offer.status === 'PENDING') {
                    <div class="pt-2 flex flex-col sm:flex-row sm:items-center justify-between gap-2 border-t border-slate-100 dark:border-slate-800">
                      <p class="text-[11px] text-slate-500 dark:text-slate-400">
                        Para cambiar la oferta es necesario cancelarla y presentar una nueva (perdiendo prioridad de llegada).
                      </p>
                      <button
                        type="button"
                        [id]="'btn-cancel-coach-offer-' + offer.id"
                        (click)="promptCancelCoachOffer(offer)"
                        [disabled]="!game.canAction('bidCoach') || (!canCancelCoachOffer(offer))"
                        class="px-3.5 py-1.5 text-xs font-semibold text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-950/40 border border-rose-200 dark:border-rose-900/60 rounded-xl transition-colors cursor-pointer shrink-0 disabled:opacity-50"
                      >
                        {{ game.t('coaches.cancel_offer') }}
                      </button>
                    </div>
                  }
                </div>
                }
              }
            </div>
          } @else {
            <div class="text-center py-12 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-8 shadow-xs">
              <app-icon name="file-text" [size]="32" class="mx-auto text-slate-400 mb-2" />
              <h4 class="text-sm font-bold text-slate-900 dark:text-white">No hay ofertas que coincidan con estos filtros</h4>
              <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 max-w-sm mx-auto">
                Prueba a seleccionar otros filtros para consultar tus ofertas por entrenadores.
              </p>
            </div>
          }
        </div>
      }
    </div>
  }

  <!-- ========================================== -->
  <!-- TAB 3: OFERTAS (ACTIVAS E HISTORIAL)       -->
  <!-- ========================================== -->
  @if (activeTab === 'market' && activeMarketTab === 'offers') {
    <div class="space-y-4">
      @if (offerListFilter !== 'history' && (clubOffersError() || game.activeOffersError())) {
        <div role="alert" class="p-3 rounded-xl bg-amber-50 dark:bg-amber-950 text-sm text-amber-700 dark:text-amber-300">
          {{ clubOffersError() || game.activeOffersError() }}
          <button type="button" (click)="loadActiveOffers()" class="ml-2 underline cursor-pointer">Reintentar</button>
        </div>
      }
      @if (offerListFilter !== 'active' && game.historicalOffersError()) {
        <div role="alert" class="p-3 rounded-xl bg-amber-50 dark:bg-amber-950 text-sm text-amber-700 dark:text-amber-300">
          {{ game.historicalOffersError() }}
          <button type="button" (click)="loadHistoricalOffers()" class="ml-2 underline cursor-pointer">Reintentar</button>
        </div>
      }
      @if (isOfferListLoading()) {
        <p role="status" class="text-xs text-slate-500 dark:text-slate-400">Actualizando ofertas…</p>
      }
      <div class="grid grid-cols-1 lg:grid-cols-2 gap-4">
        @for (group of groupedOffers(); track group.key) {
          @if (group.label) {
            <div class="col-span-full flex items-center justify-between pt-1">
              <h3 class="flex items-center gap-2 text-xs font-bold text-slate-700 dark:text-slate-300">
                <app-icon name="calendar" [size]="14" class="text-indigo-500 dark:text-indigo-400" />
                <span>{{ group.label }}</span>
              </h3>
              <span class="text-[11px] font-mono text-slate-400 dark:text-slate-500">{{ group.items.length }} {{ group.items.length === 1 ? 'oferta' : 'ofertas' }}</span>
            </div>
          }
          @for (entry of group.items; track entry.key) {
          @if (entry.active; as offer) {
                <div
                  class="bg-white dark:bg-slate-900 border rounded-2xl p-5 shadow-xs flex flex-col justify-between space-y-4 transition-all"
                  [ngClass]="offer.hasUserOffer ? 'border-emerald-300 dark:border-emerald-800/80 bg-emerald-50/10' : 'border-slate-200 dark:border-slate-800'"
                >
                  <div>
                    <!-- Offer Header: Player and Badges -->
                    <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                      <div class="flex items-center space-x-3 min-w-0 w-full sm:flex-1">
                        @if (activePlayerCrest(offer); as crest) {
                          <img [src]="crest" [alt]="activePlayerClub(offer)?.name || ''"
                            (error)="onCrestError($event)" class="w-10 h-10 object-contain shrink-0"
                            referrerpolicy="no-referrer" />
                        }
                        <div class="min-w-0 flex-1">
                          <div class="flex items-center gap-x-2 gap-y-1 flex-wrap">
                        <span class="px-2 py-0.5 rounded text-[10px] font-bold border shrink-0" [ngClass]="getPositionBadge(offer.position)">
                          {{ offer.position }}
                        </span>
                          <h3 class="text-base font-bold text-slate-900 dark:text-white whitespace-normal break-words min-w-0" [title]="offer.displayName">
                            @if (offer.playerDefinitionId && !offer.isAmateur) {
                              <button type="button" (click)="openOfferPlayerProfile(offer)" class="max-w-full whitespace-normal break-words text-left cursor-pointer hover:underline focus-visible:underline" [attr.aria-label]="'Ver ficha de ' + offer.displayName">{{ offer.displayName }}</button>
                            } @else {
                              {{ offer.displayName }}
                            }
                          </h3>
                          </div>
                          <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 flex items-center space-x-1.5 flex-wrap">
                            @if (activePlayerAge(offer); as age) {
                              <span>{{ age }} años</span>
                              @if (activePlayerClub(offer)) { <span>·</span> }
                            }
                            @if (activePlayerClub(offer); as club) {
                              <span class="font-semibold text-slate-700 dark:text-slate-300">{{ club.name }}</span>
                            }
                          </p>
                          <p class="flex flex-wrap gap-x-1 gap-y-0.5 text-[11px] text-slate-500 dark:text-slate-400 mt-0.5">
                            <span>{{ offer.operationType === 'RENEWAL' ? 'Renovación de contrato' : (offer.source === 'CLUB' ? 'Jugador de otro club' : 'Jugador libre') }}</span>
                            @if (offer.marketValueKnown !== false) {
                              <span class="whitespace-nowrap">· Valor: <strong class="font-mono">{{ (offer.marketValue / 1000000).toFixed(2) }} M€</strong></span>
                            }
                          </p>
                        </div>
                      </div>

                      <!-- Status Badge -->
                      <div class="shrink-0 text-right self-end order-first sm:order-last sm:self-start">
                        @if (offer.hasUserOffer) {
                          <span class="inline-flex items-center space-x-1 px-2.5 py-1 rounded-lg text-[11px] font-bold border" [ngClass]="getStatusBadge(offer.status)">
                            <app-icon name="check-circle" [size]="12" />
                            <span>{{ getOfferStatusLabel(offer.status) }}</span>
                          </span>
                        } @else {
                          <span class="inline-flex items-center space-x-1 px-2.5 py-1 rounded-lg text-[11px] font-semibold bg-slate-100 dark:bg-slate-800 text-slate-600 dark:text-slate-300 border border-slate-200 dark:border-slate-700">
                            <app-icon name="clock" [size]="12" />
                            <span>DISPONIBLE</span>
                          </span>
                        }
                      </div>
                    </div>

                    <!-- Financial Terms Detail Box -->
                    @if (offer.hasUserOffer) {
                      <!-- User's formal submitted offer breakdown -->
                      <div class="mt-4 p-2.5 sm:p-3.5 bg-slate-50 dark:bg-slate-950/80 rounded-xl border border-slate-200 dark:border-slate-800 space-y-2.5">
                        <div class="text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400">
                          {{ offer.operationType === 'RENEWAL' ? 'Términos de la renovación' : 'Términos de la oferta presentada' }}
                        </div>
                        <div class="grid gap-2 text-xs" [ngClass]="offer.operationType === 'RENEWAL' ? 'grid-cols-2' : 'grid-cols-3'">
                          @if (offer.operationType !== 'RENEWAL') {
                          <div>
                            <div class="text-[10px] text-slate-500 dark:text-slate-400">Traspaso</div>
                            <div class="font-bold font-mono text-emerald-700 dark:text-emerald-400 text-xs sm:text-sm whitespace-nowrap">
                              {{ (offer.transferAmount / 1000000).toFixed(2) }} M€
                            </div>
                          </div>
                          }

                          <div>
                            <div class="text-[10px] text-slate-500 dark:text-slate-400">Ficha Anual</div>
                            <div class="font-bold font-mono text-slate-900 dark:text-white text-xs sm:text-sm whitespace-nowrap">
                              {{ (offer.annualSalary / 1000000).toFixed(2) }} M€
                            </div>
                          </div>

                          <div>
                            <div class="text-[10px] text-slate-500 dark:text-slate-400">Cláusula</div>
                            <div class="font-bold font-mono text-slate-900 dark:text-white text-xs sm:text-sm whitespace-nowrap">
                              {{ (offer.releaseClause / 1000000).toFixed(1) }} M€
                            </div>
                          </div>
                        </div>


                      </div>
                    } @else {
                      <!-- Active Market Target available for bidding -->
                      <div class="mt-4 p-3.5 bg-slate-50 dark:bg-slate-950/70 rounded-xl border border-slate-100 dark:border-slate-800/80 text-xs">
                        <div class="flex items-center justify-between">
                          <span class="text-slate-500 dark:text-slate-400 text-[11px]">
                            Licitación de la ventana diaria ({{ latestCutoffAt().split('T')[0] || '2026-09-28' }}).
                          </span>
                          <span class="text-emerald-700 dark:text-emerald-400 font-bold font-mono">
                            {{ (offer.marketValue / 1000000).toFixed(2) }} M€ base
                          </span>
                        </div>
                      </div>
                    }
                  </div>

                  <!-- Card Action Footer -->
                  <div class="pt-2 border-t border-slate-100 dark:border-slate-800 flex items-center justify-end">
                    @if (canEditOffer(offer)) {
                    <button
                      type="button"
                      (click)="openNegotiationForOfferItem(offer)"
                      class="px-4 py-2 rounded-xl text-xs font-semibold cursor-pointer transition-all shadow-xs flex items-center space-x-1.5"
                      [ngClass]="offer.hasUserOffer ? 'bg-slate-100 hover:bg-slate-200 dark:bg-slate-800 dark:hover:bg-slate-700 text-slate-900 dark:text-white' : 'bg-emerald-600 hover:bg-emerald-700 text-white'"
                    >
                      <app-icon name="file-text" [size]="13" />
                      <span>{{ offer.hasUserOffer ? 'Modificar Oferta' : 'Presentar Oferta' }}</span>
                    </button>
                    } @else {
                      <span class="text-xs text-slate-500 dark:text-slate-400">
                        {{ offer.clubDecision === 'ACCEPTED' ? 'Elegida por el vendedor' : offer.clubDecision === 'REJECTED' ? 'Rechazada por el vendedor' : 'Pendiente de resolución' }}
                      </span>
                    }
                  </div>
                </div>
          } @else if (entry.history; as item) {
                @let statusInfo = getHistoryStatusInfo(item.status, item.rejectionReason || item.transferReason);
                <div
                  class="bg-white dark:bg-slate-900 border rounded-2xl p-5 shadow-xs flex flex-col justify-between space-y-4 transition-all"
                  [ngClass]="item.status === 'WON' ? 'border-emerald-300 dark:border-emerald-800/70 bg-emerald-50/15 dark:bg-emerald-950/10' : (item.status === 'LOST' ? 'border-rose-200 dark:border-rose-900/60 bg-rose-50/10 dark:bg-rose-950/10' : 'border-slate-200 dark:border-slate-800')"
                >
                  <div class="space-y-3.5">
                    <!-- Historical Card Header -->
                    <div class="flex flex-col sm:flex-row sm:items-start sm:justify-between gap-3">
                      <div class="flex items-center space-x-3 min-w-0 w-full sm:flex-1">
                        @if (historicalPlayerCrest(item); as crest) {
                          <img [src]="crest" [alt]="historicalPlayerClub(item)?.name || ''"
                            (error)="onCrestError($event)" class="w-10 h-10 object-contain shrink-0"
                            referrerpolicy="no-referrer" />
                        }
                        <div class="min-w-0 flex-1">
                          <div class="flex items-center gap-x-2 gap-y-1 flex-wrap">
                            @if (historicalPlayerPosition(item); as position) {
                              <span class="px-2 py-0.5 rounded text-[10px] font-bold border shrink-0" [ngClass]="getPositionBadge(position)">{{ position }}</span>
                            }
                          <h3 class="text-base font-bold text-slate-900 dark:text-white whitespace-normal break-words min-w-0" [title]="item.playerName || 'Futbolista'">
                            @if (item.playerDefinitionId) {
                              <button type="button" (click)="openHistoricalPlayerProfile(item)" class="max-w-full whitespace-normal break-words text-left cursor-pointer hover:underline focus-visible:underline" [attr.aria-label]="'Ver ficha de ' + (item.playerName || 'Futbolista')">{{ item.playerName || 'Futbolista' }}</button>
                            } @else {
                              {{ item.playerName || 'Futbolista' }}
                            }
                          </h3>
                          </div>
                          <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 flex items-center space-x-1.5 flex-wrap">
                            @if (historicalPlayerAge(item); as age) {
                              <span>{{ age }} años</span>
                              @if (historicalPlayerClub(item)) { <span>·</span> }
                            }
                            @if (historicalPlayerClub(item); as club) {
                              <span class="font-semibold text-slate-700 dark:text-slate-300">{{ club.name }}</span>
                            }
                          </p>
                          <div class="flex flex-wrap items-center gap-x-2 gap-y-0.5 mt-0.5 text-[11px] text-slate-500 dark:text-slate-400">
                            <span class="whitespace-nowrap">{{ historyOfferTypeLabel(item) }}</span>
                            <span>Enviada: <strong>{{ formatHistoryDate(item.submittedAt) }}</strong></span>
                          </div>
                        </div>
                      </div>

                      <!-- Outcome Badge -->
                      <div class="shrink-0 text-right self-end order-first sm:order-last sm:self-start">
                        <span class="inline-flex items-center space-x-1 px-2.5 py-1 rounded-lg text-[11px] font-bold border" [ngClass]="statusInfo.class">
                          <app-icon [name]="statusInfo.icon" [size]="13" />
                          <span>{{ statusInfo.label }}</span>
                        </span>
                      </div>
                    </div>

                    <!-- Motivo del Rechazo (Literal y badge explicativo cuando existe motivo registrado) -->
                    @if (item.rejectionReason || item.transferReason; as reason) {
                      <div class="flex items-center space-x-2 px-3 py-2 bg-rose-50/90 dark:bg-rose-950/40 border border-rose-200/90 dark:border-rose-900/60 rounded-xl text-xs text-rose-900 dark:text-rose-200 shadow-2xs">
                        <app-icon [name]="getRejectionReasonIcon(reason)" [size]="15" class="text-rose-600 dark:text-rose-400 shrink-0" />
                        <div class="flex flex-wrap items-center gap-x-1.5 gap-y-0.5 leading-snug">
                          <span class="text-[11px] font-bold uppercase tracking-wider text-rose-700 dark:text-rose-400">
                            {{ game.t('market.rejection_reason_title') }}:
                          </span>
                          <span class="font-semibold text-slate-800 dark:text-rose-100">
                            {{ getRejectionReasonLabel(reason, item.boardLimit) }}
                          </span>
                        </div>
                      </div>
                    }

                    <!-- Terms Grid -->
                    <div class="p-2.5 sm:p-3.5 bg-slate-50 dark:bg-slate-950/80 rounded-xl border border-slate-200 dark:border-slate-800/80 space-y-2.5">
                      <div class="text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400 flex items-center justify-between">
                        <span>Detalle de la Propuesta Formal</span>
                        <span class="font-mono text-[10px] text-slate-400">Versión: v{{ item.version || 1 }}</span>
                      </div>

                      <div class="grid grid-cols-3 gap-2 text-xs">
                        <div>
                          <div class="text-[10px] text-slate-500 dark:text-slate-400">Traspaso</div>
                          <div class="font-bold font-mono text-xs sm:text-sm whitespace-nowrap" [ngClass]="item.status === 'WON' ? 'text-emerald-700 dark:text-emerald-400' : 'text-slate-900 dark:text-white'">
                            {{ (item.terms.transferAmount / 1000000).toFixed(2) }} M€
                          </div>
                        </div>

                        <div>
                          <div class="text-[10px] text-slate-500 dark:text-slate-400">Ficha Anual</div>
                          <div class="font-bold font-mono text-slate-900 dark:text-white text-xs sm:text-sm whitespace-nowrap">
                            {{ (item.terms.annualSalary / 1000000).toFixed(2) }} M€
                          </div>
                        </div>

                        <div>
                          <div class="text-[10px] text-slate-500 dark:text-slate-400">Cláusula</div>
                          <div class="font-bold font-mono text-slate-900 dark:text-white text-xs sm:text-sm whitespace-nowrap">
                            {{ (item.terms.releaseClause / 1000000).toFixed(1) }} M€
                          </div>
                        </div>
                      </div>
                      
                    </div>
                  </div>
                </div>
          }
          }
        } @empty {
          @if (!isOfferListLoading()) {
            <p class="col-span-full py-12 text-center text-sm text-slate-500 dark:text-slate-400">No hay ofertas que coincidan con estos filtros.</p>
          }
        }
      </div>
      @if (offerListFilter !== 'active') {
        <p class="text-xs text-slate-500 dark:text-slate-400">Las ofertas históricas corresponden a la página actual.</p>
          @if (game.historicalOffersData(); as history) {
            @if (history.totalPages > 1) {
              <nav aria-label="Paginación del historial" class="flex items-center justify-between gap-3 text-xs">
                <button type="button" (click)="loadHistoricalOffers(history.page - 1)"
                  [disabled]="history.page === 0 || game.isHistoricalOffersLoading()"
                  class="px-3 py-2 rounded-lg border border-slate-300 dark:border-slate-700 disabled:opacity-40">Anterior</button>
                <span>Página {{ history.page + 1 }} de {{ history.totalPages }} · {{ history.totalElements }} ofertas</span>
                <button type="button" (click)="loadHistoricalOffers(history.page + 1)"
                  [disabled]="history.page + 1 >= history.totalPages || game.isHistoricalOffersLoading()"
                  class="px-3 py-2 rounded-lg border border-slate-300 dark:border-slate-700 disabled:opacity-40">Siguiente</button>
              </nav>
            }
          }
      }
    </div>
  }

  <!-- ========================================== -->
  <!-- TAB 3: CARTERA (FUTBOLISTAS EN SEGUIMIENTO) -->
  <!-- ========================================== -->
  @if (activeTab === 'watchlist') {
    <div class="space-y-6">
      <!-- Cartera Banner Header -->
      <!--<div class="p-4 bg-slate-900 border border-slate-800 text-white rounded-2xl flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 shadow-sm">
        <div class="flex items-start sm:items-center space-x-3">
          <div class="p-2.5 rounded-xl bg-emerald-500/20 text-emerald-400 border border-emerald-500/30 shrink-0">
            <app-icon name="bookmark" [size]="20" />
          </div>
          <div>
            <div class="flex items-center gap-2">
              <h3 class="text-base font-bold text-white">
                Cartera de Jugadores (Mercado Global)
              </h3>
              <span
                class="px-2.5 py-0.5 rounded-full text-xs font-mono font-bold"
                [ngClass]="game.hasMaxPortfolio() ? 'bg-amber-500/20 text-amber-300 border border-amber-500/30' : 'bg-emerald-500/20 text-emerald-300 border border-emerald-500/30'"
              >
                {{ game.portfolioCount() }}/3 en cartera
              </span>
            </div>
            <p class="text-slate-300 text-xs mt-1 max-w-2xl">
              Añade hasta 3 jugadores con contrato de otros clubes para monitorizarlos. Las cláusulas de rescisión se descubren al finalizar el siguiente <strong>cierre diario del mercado</strong>.
            </p>
          </div>
        </div>

        <div class="flex items-center gap-2 self-start sm:self-auto shrink-0">
          @if (game.hasMaxPortfolio()) {
            <span class="text-xs px-3 py-1.5 rounded-xl bg-amber-500/10 text-amber-300 border border-amber-500/30 font-medium">
              Límite máximo alcanzado (3/3)
            </span>
          } @else {
            <button
              type="button"
              (click)="router.navigate(['/competition'])"
              class="px-3.5 py-1.5 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold transition-colors flex items-center space-x-1 cursor-pointer"
            >
              <app-icon name="shield" [size]="14" />
              <span>Ver Clubes de la Liga</span>
            </button>
          }
        </div>
      </div>-->

      <!-- Explanatory note if full -->
      @if (game.hasMaxPortfolio()) {
        <div class="p-3.5 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-900/60 text-amber-800 dark:text-amber-300 text-xs flex items-center gap-2">
          <app-icon name="info" [size]="16" class="shrink-0" />
          <span>Has alcanzado el límite máximo de 3 jugadores en cartera. Para añadir un nuevo jugador, primero debes retirar uno de los actuales.</span>
        </div>
      }

      @if (portfolioOwnerError()) {
        <div class="text-sm text-amber-700 dark:text-amber-300" role="status">
          {{ portfolioOwnerError() }}
          <button type="button" class="ml-2 underline cursor-pointer" (click)="loadPortfolio(true)">Reintentar</button>
        </div>
      }

      <!-- Portfolio Items Grid -->
      @if (game.portfolioItems().length > 0) {
        <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
          @for (item of game.portfolioItems(); track item.playerId) {
            <div class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 hover:border-slate-300 dark:hover:border-slate-700 rounded-2xl p-5 transition-all shadow-xs flex flex-col justify-between space-y-4">
              <div>
                <!-- Top: Crest, Player Info, Position, Media -->
                <div class="flex items-start justify-between gap-3">
                  <div class="flex items-center space-x-3 min-w-0">
                    <!-- Club Crest Shield -->
                    @if (getPortfolioItemCrestUrl(item); as crestUrl) {
                      <img
                        [src]="crestUrl"
                        [alt]="getPortfolioItemClubName(item)"
                        (error)="onCrestError($event)"
                        class="w-10 h-10 object-contain shrink-0"
                        referrerpolicy="no-referrer"
                      />
                    } @else {
                      <div class="w-10 h-10 rounded-xl bg-slate-100 dark:bg-slate-800 flex items-center justify-center text-slate-400 shrink-0">
                        <app-icon name="shield" [size]="20" />
                      </div>
                    }

                    <div class="min-w-0">
                      <div class="flex items-center space-x-2 flex-wrap gap-y-1">
                        <span class="px-2 py-0.5 rounded text-[10px] font-bold border shrink-0" [ngClass]="getPositionBadge(getPortfolioItemPosition(item))">
                          {{ getPortfolioItemPosition(item) }}
                        </span>
                        <h3 class="text-base font-bold text-slate-900 dark:text-white truncate" [title]="item.displayName || item.name">
                          {{ item.displayName || item.name || 'Futbolista' }}
                        </h3>
                      </div>
                      <p class="text-xs text-slate-500 dark:text-slate-400 mt-1 flex items-center space-x-1.5 flex-wrap">
                        @if (item.age) {
                          <span>{{ item.age }} años</span>
                          <span>·</span>
                        }
                        <span class="font-semibold text-slate-700 dark:text-slate-300">
                          {{ getPortfolioItemClubName(item) }}
                        </span>
                      </p>
                    </div>
                  </div>

                  <!-- Right Top: Media Badge -->
                  <div class="flex items-center space-x-2 shrink-0">
                    <div class="text-right">
                      <div class="text-2xl font-bold text-slate-900 dark:text-white font-mono leading-none">
                        {{ item.averagePoints != null ? formatAvg(item.averagePoints) : (item.overall || 75) }}
                      </div>
                      <div class="text-[10px] uppercase font-bold text-slate-400">Media</div>
                    </div>
                  </div>
                </div>

                <!-- Unavailabilities Chips if any -->
                @if (item.unavailabilities && item.unavailabilities.length > 0) {
                  <div class="mt-3 flex flex-wrap gap-1.5">
                    @for (unav of item.unavailabilities; track $index) {
                      <div
                        class="inline-flex items-center space-x-1.5 px-2.5 py-1 rounded-lg text-xs font-medium border shadow-2xs"
                        [ngClass]="getUnavailabilityBadgeClass(unav.type)"
                        [title]="(unav.typeLabel || getUnavailabilityTypeLabel(unav.type)) + ': ' + (unav.reasonLabel || getUnavailabilityReasonLabel(unav.reason))"
                      >
                        <app-icon [name]="getUnavailabilityIcon(unav.type)" [size]="13" class="shrink-0" />
                        <span class="font-bold text-[10px] uppercase tracking-wide">{{ unav.typeLabel || getUnavailabilityTypeLabel(unav.type) }}:</span>
                        <span class="truncate max-w-[200px]">{{ unav.reasonLabel || getUnavailabilityReasonLabel(unav.reason) }}</span>
                      </div>
                    }
                  </div>
                }

                <!-- Club Propietario -->
                <div class="mt-3 flex items-center gap-2 text-xs text-slate-500 dark:text-slate-400">
                  <app-icon name="shield" [size]="14" class="shrink-0" />
                  <span class="shrink-0">Club propietario:</span>
                  <span class="min-w-0 truncate font-semibold text-slate-700 dark:text-slate-300" [title]="getPortfolioOwnerClubName(item)">
                    {{ getPortfolioOwnerClubName(item) }}
                  </span>
                </div>

                <!-- Financial Metrics Grid (Valor Mercado & Cláusula de Rescisión) -->
                <div class="grid grid-cols-2 gap-2 mt-4 p-3 bg-slate-50 dark:bg-slate-950/70 rounded-xl border border-slate-100 dark:border-slate-800/80 text-xs">
                  <div>
                    <div class="text-[10px] text-slate-500 dark:text-slate-400">Valor Mercado</div>
                    <div class="font-bold text-slate-900 dark:text-white font-mono mt-0.5">
                      {{ getPortfolioItemMarketValueM(item) }} M€
                    </div>
                  </div>

                  <div>
                    <div class="text-[10px] text-slate-500 dark:text-slate-400">Cláusula de Rescisión</div>
                    <div class="font-mono mt-0.5">
                      @if (isPortfolioItemDiscovered(item) && getPortfolioItemClauseM(item); as clauseM) {
                        <div class="font-bold text-rose-600 dark:text-rose-400 text-sm">
                          {{ clauseM }} M€
                        </div>
                      } @else {
                        <div class="text-xs font-semibold text-amber-600 dark:text-amber-400 flex items-center gap-1 font-sans">
                          <app-icon name="clock" [size]="12" />
                          <span title="Se descubrirá al finalizar el siguiente cierre diario">Sin descubrir (al cierre)</span>
                        </div>
                      }
                    </div>
                  </div>
                </div>
              </div>

              <!-- Card Action Footer -->
              <div class="pt-2 border-t border-slate-100 dark:border-slate-800 flex items-center gap-2">
                <button
                  type="button"
                  (click)="removePlayerFromPortfolio(item.playerId)"
                  class="py-2.5 px-3 rounded-xl border border-slate-200 dark:border-slate-700 text-xs font-semibold text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 transition-all cursor-pointer flex items-center justify-center space-x-1 shrink-0"
                  title="Retirar de cartera"
                >
                  <app-icon name="trash" [size]="14" />
                  <span>Quitar</span>
                </button>

                @if (canAttemptClause(item)) {
                  <button
                    type="button"
                    (click)="openReleaseClauseModal(item)"
                    [disabled]="!game.canAction('placeOffer')"
                    class="flex-1 py-2.5 px-4 rounded-xl bg-emerald-600 hover:bg-emerald-700 text-white text-xs font-semibold transition-all shadow-xs cursor-pointer flex items-center justify-center space-x-1.5 active:scale-98 disabled:opacity-50"
                    title="Presentar oferta pagando la cláusula descubierta"
                  >
                    <app-icon name="zap" [size]="14" />
                    <span>Presentar Clausulazo</span>
                  </button>
                } @else {
                  <button
                    type="button"
                    disabled
                    class="flex-1 py-2.5 px-4 rounded-xl bg-slate-100 dark:bg-slate-800 text-slate-400 dark:text-slate-500 text-xs font-medium cursor-not-allowed flex items-center justify-center space-x-1.5 border border-slate-200 dark:border-slate-700"
                    title="La cláusula se descubrirá al finalizar el siguiente cierre diario"
                  >
                    <app-icon name="lock" [size]="14" />
                    <span>Pagar cláusula</span>
                  </button>
                }
              </div>
            </div>
          }
        </div>
      } @else {
        <!-- Empty Watchlist State -->
        <div class="text-center py-16 bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 p-8 shadow-xs">
          <div class="w-14 h-14 rounded-2xl bg-slate-100 dark:bg-slate-800 text-emerald-600 dark:text-emerald-400 flex items-center justify-center mx-auto">
            <app-icon name="bookmark" [size]="28" />
          </div>
          <h3 class="text-base font-bold text-slate-900 dark:text-white mt-4">
            Tu Cartera de Jugadores está vacía (0/3)
          </h3>
          <p class="text-xs text-slate-500 dark:text-slate-400 mt-1.5 max-w-md mx-auto leading-relaxed">
            Puedes añadir hasta <strong>3 futbolistas</strong> con contrato en otro club. Al añadirlos, sus cláusulas quedarán pendientes de descubrir y se revelarán al finalizar el siguiente <strong>cierre diario</strong>, momento en el cual podrás realizar una oferta pagando la cláusula.
          </p>
        </div>
      }
    </div>
  }

  <!-- ========================================== -->
  <!-- MODAL: PRESENTAR OFERTA FORMAL             -->
  <!-- ========================================== -->
  @if (negotiatingPlayer) {
    <!-- Requisito: que el popup se cierre solo al aceptar, cancelar o pulsar la X -->
    <div class="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-xs p-4">
      <div
        class="bg-white dark:bg-slate-900 border border-slate-200 dark:border-slate-800 rounded-2xl p-6 max-w-md w-full shadow-2xl space-y-4"
      >
        <!-- Modal Header -->
        <div class="flex items-center justify-between pb-3 border-b border-slate-100 dark:border-slate-800">
          <div class="flex items-center space-x-3">
            @if (getPlayerClubShortName(negotiatingPlayer); as crestCode) {
              <img
                [src]="getPlayerCrestUrl(negotiatingPlayer)"
                [alt]="getPlayerClubName(negotiatingPlayer)"
                (error)="onCrestError($event)"
                class="w-10 h-10 object-contain shrink-0"
                referrerpolicy="no-referrer"
              />
            }
            <div>
              <div class="text-[10px] uppercase font-bold text-slate-400">
                {{ editingOfferId ? 'Modificar Oferta Existente' : 'Propuesta Contractual' }} · {{ getPlayerClubName(negotiatingPlayer) }}
              </div>
              <h3 class="text-lg font-bold text-slate-900 dark:text-white leading-tight">
                {{ editingOfferId ? 'Modificar oferta por ' + negotiatingPlayer.name : 'Negociar con ' + negotiatingPlayer.name }}
              </h3>
            </div>
          </div>
          <button
            type="button"
            (click)="closeNegotiationModal()"
            class="p-2 text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 rounded-lg hover:bg-slate-100 dark:hover:bg-slate-800 transition-colors cursor-pointer"
            title="Cerrar modal"
          >
            <app-icon name="x" [size]="18" />
          </button>
        </div>

        <!-- Error Alert Banner -->
        @if (modalError(); as errorMsg) {
          <div
            id="offer-submission-error-alert"
            class="p-3.5 rounded-xl border border-rose-200 dark:border-rose-800/70 bg-rose-50 dark:bg-rose-950/40 text-rose-800 dark:text-rose-300 text-xs flex items-start space-x-2.5 animate-in fade-in duration-150"
          >
            <app-icon name="alert-circle" [size]="16" class="text-rose-600 dark:text-rose-400 shrink-0 mt-0.5" />
            <div class="flex-1 font-medium leading-relaxed">
              {{ errorMsg }}
            </div>
          </div>
        }



        <!-- Unavailability Alert in Modal -->
        @if (negotiatingPlayer.unavailabilities && negotiatingPlayer.unavailabilities.length > 0) {
          <div class="p-3.5 rounded-xl border border-rose-200 dark:border-rose-900/60 bg-rose-50 dark:bg-rose-950/40 text-xs text-rose-800 dark:text-rose-300 space-y-1.5 animate-in fade-in duration-150">
            <div class="flex items-center space-x-2 font-bold uppercase text-[10px] tracking-wider text-rose-700 dark:text-rose-300">
              <app-icon name="alert-circle" [size]="15" class="shrink-0" />
              <span>Aviso de No Disponibilidad</span>
            </div>
            <div class="space-y-1 pl-6">
              @for (unav of negotiatingPlayer.unavailabilities; track $index) {
                <div class="flex items-center space-x-1.5 flex-wrap">
                  <span class="font-bold uppercase text-[10px] px-1.5 py-0.5 rounded bg-rose-100 dark:bg-rose-900/50 text-rose-800 dark:text-rose-200">{{ unav.typeLabel || getUnavailabilityTypeLabel(unav.type) }}</span>
                  <span class="font-medium text-slate-800 dark:text-slate-200">{{ unav.reasonLabel || getUnavailabilityReasonLabel(unav.reason) }}</span>
                  @if (unav.expectedEndDate) {
                    <span class="text-rose-600 dark:text-rose-400 text-[11px] font-normal">(baja estimada hasta {{ unav.expectedEndDate }})</span>
                  }
                </div>
              }
            </div>
          </div>
        }

        <!-- Form fields -->
        @if (negotiatingPlayer.marketSource === 'CLUB_LISTING') {
          <p class="text-xs text-slate-500 dark:text-slate-400">
            El propietario recibirá la oferta en el cierre diario. Si la acepta, el traspaso se resolverá en el siguiente cierre,
            sujeto a la aceptación del jugador según el sueldo y la clasificación de ambos clubes. No hay prima de fichaje.
          </p>
        }
        <div class="space-y-3.5 text-xs">
          <!-- Oferta de Traspaso (transferAmount) -->
          <div>
            <div class="flex justify-between items-center mb-1">
              <label for="offered-transfer-fee-input" class="font-semibold text-slate-700 dark:text-slate-300">
                Oferta de Traspaso (transferAmount)
              </label>
            </div>
            <div class="relative">
              <input
                id="offered-transfer-fee-input"
                type="text" inputmode="decimal" appMoneyInput
                step="0.1"
                min="0"
                [(ngModel)]="offeredTransferFee"
                class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm font-mono text-emerald-600 dark:text-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 pr-28"
              />
              <span class="absolute right-3.5 top-2.5 text-xs text-slate-400 font-mono pointer-events-none">
                {{ (offeredTransferFee * 1000000) | number:'1.0-0' }} €
              </span>
            </div>
          </div>

          <!-- Ficha Anual (annualSalary) -->
          <div>
            <div class="flex justify-between items-center mb-1">
              <label for="offered-salary-input" class="font-semibold text-slate-700 dark:text-slate-300">
                Ficha Anual Neta (annualSalary)
              </label>
            </div>
            <div class="relative">
              <input
                id="offered-salary-input"
                type="text" inputmode="decimal" appMoneyInput
                step="0.1"
                min="0.1"
                [(ngModel)]="offeredSalary"
                class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm font-mono text-emerald-600 dark:text-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 pr-28"
              />
              <span class="absolute right-3.5 top-2.5 text-xs text-slate-400 font-mono pointer-events-none">
                {{ (offeredSalary * 1000000) | number:'1.0-0' }} €/año
              </span>
            </div>
          </div>

          <!-- Cláusula de Rescisión (releaseClause) -->
          <div>
            <div class="flex justify-between items-center mb-1">
              <label for="offered-clause-input" class="font-semibold text-slate-700 dark:text-slate-300">
                Cláusula de Rescisión (releaseClause)
              </label>              
            </div>
            <div class="relative">
              <input
                id="offered-clause-input"
                type="text" inputmode="decimal" appMoneyInput
                step="1"
                min="1"
                [(ngModel)]="offeredClause"
                class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm font-mono text-emerald-600 dark:text-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 pr-28"
              />
              <span class="absolute right-3.5 top-2.5 text-xs text-slate-400 font-mono pointer-events-none">
                {{ (offeredClause * 1000000) | number:'1.0-0' }} €
              </span>
            </div>
          </div>

          <!-- Real-Time Evaluation Box 
          @if (evaluationPreview(); as evalRes) {
            <div
              class="p-3.5 rounded-xl border text-xs space-y-1"
              [ngClass]="evalRes.accepted ? 'bg-emerald-50 border-emerald-200 text-emerald-800 dark:bg-emerald-950/40 dark:border-emerald-800/60 dark:text-emerald-300' : 'bg-rose-50 border-rose-200 text-rose-800 dark:bg-rose-950/40 dark:border-rose-800/60 dark:text-rose-300'"
            >
              <div class="flex items-center space-x-1.5 font-bold">
                <app-icon [name]="evalRes.accepted ? 'check-circle' : 'alert-circle'" [size]="14" />
                <span>{{ evalRes.accepted ? 'El futbolista aceptará esta propuesta' : 'Propuesta insuficiente para el jugador' }}</span>
              </div>
              <p class="text-[11px] opacity-90">{{ evalRes.reason }}</p>
            </div>
          }-->

          <!-- Budget info -->
          <div class="flex items-center justify-between text-xs pt-1 px-1">
            <span class="text-slate-500 dark:text-slate-400">
              Coste Inicial Estimado:
              <strong class="text-slate-900 dark:text-white ml-1">{{ totalRequiredFunds() }} M€</strong>
            </span>
            <span class="text-emerald-700 dark:text-emerald-400 font-semibold">
              Saldo Club: {{ game.userClub().economy.availableBalance.toFixed(2) }} M€
            </span>
          </div>
        </div>

        <div class="pt-3 flex items-center justify-between border-t border-slate-100 dark:border-slate-800">
          <!-- Botón Cancelar Oferta en Servidor (PUT /api/market/offers/{offerId}/cancellation) -->
          @if (editingOfferId) {
            <button
              type="button"
              id="btn-cancel-offer-modal"
              (click)="cancelTransferOffer()"
              [disabled]="!game.canAction('placeOffer') || (isCancellingOffer() || isSubmittingOffer())"
              class="px-3.5 py-2 text-xs font-semibold text-rose-600 dark:text-rose-400 hover:bg-rose-50 dark:hover:bg-rose-950/40 border border-rose-200 dark:border-rose-900/60 rounded-xl transition-colors cursor-pointer disabled:opacity-50 flex items-center space-x-1.5"
              title="Cancelar oferta"
            >
              @if (isCancellingOffer()) {
                <div class="w-3.5 h-3.5 border-2 border-rose-600 dark:border-rose-400 border-t-transparent rounded-full animate-spin"></div>
                <span>Cancelando...</span>
              } @else {
                <app-icon name="trash" [size]="14" />
                <span>Cancelar oferta</span>
              }
            </button>
          } @else {
            <div></div>
          }

          <div class="flex items-center space-x-2">
            <button
              type="button"
              (click)="closeNegotiationModal()"
              class="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors cursor-pointer"
            >
              Volver
            </button>
            <button
              type="button"
              id="btn-submit-transfer-offer"
              (click)="submitTransferOffer()"
              [disabled]="!game.canAction('placeOffer') || (isSubmittingOffer() || isCancellingOffer())"
              [title]="editingOfferId ? 'Guardar los cambios de la oferta' : 'Presentar oferta'"
              class="px-5 py-2 text-xs font-semibold bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white rounded-xl disabled:opacity-50 cursor-pointer shadow-xs active:scale-98 flex items-center space-x-1.5 transition-all"
            >
              @if (isSubmittingOffer()) {
                <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                <span>Guardando...</span>
              } @else {
                <app-icon name="check" [size]="15" />
                <span>{{ editingOfferId ? 'Guardar Cambios' : 'Aceptar' }}</span>
              }
            </button>
          </div>
        </div>
      </div>
    </div>
  }

  <!-- ============================================== -->
  <!-- MODAL: OFERTAR POR ENTRENADOR                  -->
  <!-- ============================================== -->
  @if (showCoachOfferModal() && selectedCoachForOffer(); as coach) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 bg-slate-950/70 backdrop-blur-xs overflow-y-auto animate-in fade-in duration-150"
      role="dialog"
      aria-modal="true"
      aria-labelledby="coach-modal-title"
    >
      <div class="relative w-full max-w-lg bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-2xl p-5 sm:p-6 space-y-4 my-8">
        <!-- Modal Header -->
        <div class="flex items-start justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
          <div class="flex items-center space-x-3">
            <div class="w-12 h-12 rounded-xl overflow-hidden bg-slate-100 dark:bg-slate-800 border border-slate-200 dark:border-slate-700 shrink-0">
              @if (coach.realClub?.shortName) {
                <img [src]="getCoachCrestUrl(coach)" [alt]="coach.realClub!.name" (error)="onCrestError($event)" class="w-full h-full object-contain" referrerpolicy="no-referrer" />
              } @else {
                <div class="w-full h-full flex items-center justify-center text-slate-400">
                  <app-icon name="user" [size]="24" />
                </div>
              }
            </div>
            <div>
              <span class="text-[10px] font-bold uppercase tracking-wider text-emerald-600 dark:text-emerald-400">Licitación de Entrenador</span>
              <h3 id="coach-modal-title" class="text-base font-bold text-slate-900 dark:text-white">
                {{ coach.name }}
              </h3>
              <div class="text-[11px] text-slate-500 flex items-center space-x-2">
                <span>Ataque: <strong>+{{ coach.attack }}%</strong></span>
                <span>·</span>
                <span>Control: <strong>+{{ coach.midfield }}%</strong></span>
                <span>·</span>
                <span>Defensa: <strong>+{{ coach.defense }}%</strong></span>
              </div>
            </div>
          </div>

          <button
            type="button"
            (click)="closeCoachOfferModal()"
            id="btn-close-coach-modal"
            class="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer"
            aria-label="Cerrar modal"
          >
            <app-icon name="x" [size]="18" />
          </button>
        </div>

        <!-- Feedback Messages -->
        @if (coachModalError()) {
          <div class="p-3 bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-900/60 rounded-xl text-rose-800 dark:text-rose-300 text-xs flex items-center space-x-2">
            <app-icon name="alert-circle" [size]="16" class="shrink-0" />
            <span>{{ coachModalError() }}</span>
          </div>
        }
        @if (coachModalSuccess()) {
          <div class="p-3 bg-emerald-50 dark:bg-emerald-950/40 border border-emerald-200 dark:border-emerald-900/60 rounded-xl text-emerald-800 dark:text-emerald-300 text-xs flex items-center space-x-2">
            <app-icon name="check-circle" [size]="16" class="shrink-0" />
            <span>{{ coachModalSuccess() }}</span>
          </div>
        }

        <!-- Inputs Form -->
        <div class="space-y-3.5 text-xs">
          <!-- Prima de Fichaje (signingBonus) -->
          <div>
            <div class="flex justify-between items-center mb-1">
              <label for="coach-signing-bonus-input" class="font-semibold text-slate-700 dark:text-slate-300">
                {{ game.t('coaches.signing_bonus') }}
              </label>
            </div>
            <div class="relative">
              <input
                id="coach-signing-bonus-input"
                type="text" inputmode="decimal" appMoneyInput
                step="1000"
                min="0"
                [ngModel]="coachSigningBonus"
                (ngModelChange)="coachSigningBonus = $event ?? 0"
                class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm font-mono text-emerald-600 dark:text-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 pr-24"
              />
              <span class="absolute right-3.5 top-2.5 text-xs text-slate-400 font-mono pointer-events-none">
                EUR (€)
              </span>
            </div>
            @if (coachSigningBonusError(); as err) {
              <p class="text-[11px] text-rose-600 dark:text-rose-400 mt-1 font-medium">{{ err }}</p>
            }
          </div>

          <!-- Salario de Temporada (annualSalary) -->
          <div>
            <div class="flex justify-between items-center mb-1">
              <label for="coach-annual-salary-input" class="font-semibold text-slate-700 dark:text-slate-300">
                {{ game.t('coaches.annual_salary') }}
              </label>
            </div>
            <div class="relative">
              <input
                id="coach-annual-salary-input"
                type="text" inputmode="decimal" appMoneyInput
                step="1000"
                min="1"
                [ngModel]="coachAnnualSalary"
                (ngModelChange)="coachAnnualSalary = $event ?? 0"
                class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm font-mono text-emerald-600 dark:text-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 pr-24"
              />
              <span class="absolute right-3.5 top-2.5 text-xs text-slate-400 font-mono pointer-events-none">
                EUR (€)
              </span>
            </div>
            @if (coachAnnualSalaryError(); as err) {
              <p class="text-[11px] text-rose-600 dark:text-rose-400 mt-1 font-medium">{{ err }}</p>
            }
          </div>

          <!-- Cláusula de Rescisión (releaseClause) -->
          <div>
            <div class="flex justify-between items-center mb-1">
              <label for="coach-release-clause-input" class="font-semibold text-slate-700 dark:text-slate-300">
                {{ game.t('coaches.release_clause') }}
              </label>
            </div>
            <div class="relative">
              <input
                id="coach-release-clause-input"
                type="text" inputmode="decimal" appMoneyInput
                step="1000"
                min="0"
                [ngModel]="coachReleaseClause"
                (ngModelChange)="coachReleaseClause = $event ?? 0"
                class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm font-mono text-emerald-600 dark:text-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 pr-24"
              />
              <span class="absolute right-3.5 top-2.5 text-xs text-slate-400 font-mono pointer-events-none">
                EUR (€)
              </span>
            </div>
            @if (coachReleaseClauseError(); as err) {
              <p class="text-[11px] text-rose-600 dark:text-rose-400 mt-1 font-medium">{{ err }}</p>
            }
          </div>

          <!-- Sustitución Warning if active coach -->
          @if (game.coaches.hasActiveCoach()) {
            <div class="p-3 rounded-xl bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-800/60 text-amber-900 dark:text-amber-300 text-[11px] space-y-1">
              <div class="flex items-center space-x-1.5 font-bold">
                <app-icon name="alert-triangle" [size]="14" class="shrink-0" />
                <span>Aviso de Sustitución de Entrenador</span>
              </div>
              <p>
                Si ganas esta licitación, el contrato de <strong>{{ game.coaches.activeContract()?.name }}</strong> quedará rescindido e indemnizarás sus jornadas futuras pendientes.
              </p>
              @if (coachIndemnityEstimate(); as est) {
                <p class="text-[10px] text-amber-800 dark:text-amber-400 pt-0.5">
                  Estimación informativa no vinculante: ~<strong>{{ est | number:'1.0-2' }} €</strong> (según jornadas restantes del calendario).
                </p>
              }
            </div>
          }
        </div>

        <!-- Modal Footer -->
        <div class="pt-3 flex items-center justify-between border-t border-slate-100 dark:border-slate-800">
          <button
            type="button"
            (click)="closeCoachOfferModal()"
            class="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors cursor-pointer"
          >
            Volver
          </button>

          <button
            type="button"
            id="btn-confirm-submit-coach-offer"
            (click)="submitCoachOffer()"
            [disabled]="!game.canAction('bidCoach') || (!isCoachOfferValid() || game.coaches.isSubmittingOffer())"
            class="px-5 py-2 text-xs font-semibold bg-emerald-600 hover:bg-emerald-700 active:bg-emerald-800 text-white rounded-xl disabled:opacity-50 cursor-pointer shadow-xs active:scale-98 flex items-center space-x-1.5 transition-all"
          >
            @if (game.coaches.isSubmittingOffer()) {
              <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Registrando oferta...</span>
            } @else {
              <app-icon name="check" [size]="15" />
              <span>Confirmar Oferta</span>
            }
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ============================================== -->
  <!-- MODAL: CONFIRMAR CANCELACIÓN DE OFERTA        -->
  <!-- ============================================== -->
  @if (showCoachCancelConfirmModal() && cancellingCoachOffer(); as off) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 bg-slate-950/70 backdrop-blur-xs animate-in fade-in duration-150"
      role="dialog"
      aria-modal="true"
    >
      <div class="relative w-full max-w-md bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-2xl p-5 sm:p-6 space-y-4">
        <div class="flex items-center space-x-3 text-rose-600">
          <div class="w-10 h-10 rounded-xl bg-rose-50 dark:bg-rose-950/50 flex items-center justify-center shrink-0">
            <app-icon name="trash" [size]="20" />
          </div>
          <div>
            <h3 class="text-base font-bold text-slate-900 dark:text-white">¿Cancelar oferta pendiente?</h3>
            <p class="text-xs text-slate-500">Técnico: {{ coachOfferName(off) }}</p>
          </div>
        </div>

        <p class="text-xs text-slate-600 dark:text-slate-300 leading-relaxed">
          Esta acción cancelará inmediatamente la oferta registrada en el servidor. Si deseas presentar una nueva propuesta posteriormente, se generará un nuevo identificador y perderás la prioridad de llegada original en caso de empate.
        </p>

        <div class="pt-2 flex items-center justify-end space-x-2 border-t border-slate-100 dark:border-slate-800">
          <button
            type="button"
            (click)="closeCoachCancelModal()"
            class="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors cursor-pointer"
          >
            Mantener oferta
          </button>

          <button
            type="button"
            id="btn-confirm-cancel-coach-offer"
            (click)="confirmCancelCoachOffer()"
            [disabled]="!game.canAction('bidCoach') || (!canCancelCoachOffer(off))"
            class="px-4 py-2 text-xs font-semibold bg-rose-600 hover:bg-rose-700 active:bg-rose-800 text-white rounded-xl disabled:opacity-50 cursor-pointer shadow-xs active:scale-98 flex items-center space-x-1.5 transition-all"
          >
            @if (game.coaches.isCancellingOffer()) {
              <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Cancelando...</span>
            } @else {
              <span>Confirmar Cancelación</span>
            }
          </button>
        </div>
      </div>
    </div>
  }

  <!-- ============================================== -->
  <!-- MODAL: PRESENTAR CLAUSULAZO                    -->
  <!-- ============================================== -->
  @if (showReleaseClauseModal() && selectedPortfolioItemForClause(); as item) {
    <div
      class="fixed inset-0 z-50 flex items-center justify-center p-3 sm:p-4 bg-slate-950/70 backdrop-blur-xs overflow-y-auto animate-in fade-in duration-150"
      role="dialog"
      aria-modal="true"
      aria-labelledby="clause-modal-title"
    >
      <div class="relative w-full max-w-lg bg-white dark:bg-slate-900 rounded-2xl border border-slate-200 dark:border-slate-800 shadow-2xl p-5 sm:p-6 space-y-4 my-8">
        <!-- Modal Header -->
        <div class="flex items-start justify-between border-b border-slate-100 dark:border-slate-800 pb-3">
          <div class="flex items-center space-x-3">
            @if (item.clubCode) {
              <img [src]="'crest/' + item.clubCode.toUpperCase() + '.png'" [alt]="item.clubName || 'Club'" class="w-10 h-10 object-contain shrink-0" (error)="onCrestError($event)" referrerpolicy="no-referrer" />
            }
            <div>
              <span class="text-[10px] font-bold uppercase tracking-wider text-rose-600 dark:text-rose-400">Clausulazo Directo</span>
              <h3 id="clause-modal-title" class="text-base font-bold text-slate-900 dark:text-white">
                Pagar cláusula de {{ item.name }}
              </h3>
              <p class="text-xs text-slate-500">{{ item.clubName || 'Club propietario' }} · Posición: {{ item.position }}</p>
            </div>
          </div>

          <button
            type="button"
            (click)="closeReleaseClauseModal()"
            id="btn-close-clause-modal"
            class="p-1 rounded-lg text-slate-400 hover:text-slate-600 dark:hover:text-slate-200 hover:bg-slate-100 dark:hover:bg-slate-800 cursor-pointer"
            aria-label="Cerrar modal"
          >
            <app-icon name="x" [size]="18" />
          </button>
        </div>

        <!-- Information Notice -->
        <div class="p-3 bg-amber-50 dark:bg-amber-950/40 border border-amber-200 dark:border-amber-900/60 rounded-xl text-amber-900 dark:text-amber-200 text-xs space-y-1">
          <div class="font-bold flex items-center gap-1.5">
            <app-icon name="info" [size]="14" />
            <span>Condiciones del Clausulazo</span>
          </div>
          <p class="leading-relaxed">
            El importe del traspaso corresponde a la cláusula descubierta. <strong>No hay prima de fichaje</strong> y el club propietario no puede ver ni rechazar la oferta.
            La operación queda <strong>pendiente hasta el cierre diario</strong>, donde el jugador decidirá según la valoración de su nuevo contrato.
          </p>
        </div>

        <!-- Error Message Banner (inputs preserved on error) -->
        @if (clauseModalError()) {
          <div class="p-3 bg-rose-50 dark:bg-rose-950/40 border border-rose-200 dark:border-rose-900/60 rounded-xl text-rose-800 dark:text-rose-300 text-xs flex items-center space-x-2">
            <app-icon name="alert-circle" [size]="16" class="shrink-0" />
            <span class="leading-relaxed">{{ clauseModalError() }}</span>
          </div>
        }

        <!-- Discovered Clause Overview -->
        <div class="p-3 bg-slate-50 dark:bg-slate-950 rounded-xl border border-slate-200 dark:border-slate-800 flex items-center justify-between">
          <div>
            <div class="text-[10px] uppercase font-bold text-slate-500 dark:text-slate-400">Importe del Traspaso (Cláusula)</div>
            <div class="text-lg font-bold font-mono text-rose-600 dark:text-rose-400">
              {{ clauseTransferFeeM.toFixed(2) }} M€
            </div>
          </div>
          <span class="px-2.5 py-1 rounded-lg text-xs font-bold bg-rose-100 text-rose-800 dark:bg-rose-950/60 dark:text-rose-300 border border-rose-200 dark:border-rose-800">
            Cláusula Descubierta
          </span>
        </div>

        <!-- Contract Terms Inputs -->
        <div class="space-y-3.5 text-xs">
          <!-- Ficha Anual -->
          <div>
            <div class="flex justify-between items-center mb-1">
              <label for="clause-annual-salary-input" class="font-semibold text-slate-700 dark:text-slate-300">
                Ficha Anual Ofrecida (annualSalary)
              </label>
            </div>
            <div class="relative">
              <input
                id="clause-annual-salary-input"
                type="text" inputmode="decimal" appMoneyInput
                step="0.1"
                min="0.1"
                [(ngModel)]="clauseAnnualSalaryM"
                class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm font-mono text-emerald-600 dark:text-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 pr-28"
              />
              <span class="absolute right-3.5 top-2.5 text-xs text-slate-400 font-mono pointer-events-none">
                {{ (clauseAnnualSalaryM * 1000000) | number:'1.0-0' }} €/año
              </span>
            </div>
          </div>

          <!-- Duración de Contrato -->
          <div>
            <div class="flex justify-between items-center mb-1">
              <label for="clause-seasons-input" class="font-semibold text-slate-700 dark:text-slate-300">
                Duración del Contrato (Temporadas)
              </label>
            </div>
            <select
              id="clause-seasons-input"
              [(ngModel)]="clauseContractYears"
              class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm font-medium text-slate-800 dark:text-slate-200 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500"
            >
              <option [ngValue]="1">1 temporada</option>
              <option [ngValue]="2">2 temporadas</option>
              <option [ngValue]="3">3 temporadas</option>
              <option [ngValue]="4">4 temporadas</option>
              <option [ngValue]="5">5 temporadas</option>
            </select>
          </div>

          <!-- Nueva Cláusula de Rescisión -->
          <div>
            <div class="flex justify-between items-center mb-1">
              <label for="clause-new-clause-input" class="font-semibold text-slate-700 dark:text-slate-300">
                Nueva Cláusula de Rescisión (newReleaseClause)
              </label>
            </div>
            <div class="relative">
              <input
                id="clause-new-clause-input"
                type="text" inputmode="decimal" appMoneyInput
                step="0.5"
                min="1"
                [(ngModel)]="clauseNewReleaseClauseM"
                class="w-full px-3.5 py-2.5 bg-slate-50 dark:bg-slate-950 border border-slate-200 dark:border-slate-800 rounded-xl text-sm font-mono text-emerald-600 dark:text-emerald-400 focus:outline-none focus:ring-2 focus:ring-emerald-500/20 focus:border-emerald-500 pr-28"
              />
              <span class="absolute right-3.5 top-2.5 text-xs text-slate-400 font-mono pointer-events-none">
                {{ (clauseNewReleaseClauseM * 1000000) | number:'1.0-0' }} €
              </span>
            </div>
          </div>

          <!-- Prima de fichaje: fijada en 0 -->
          <div class="p-2.5 bg-slate-100 dark:bg-slate-800/60 rounded-xl text-[11px] text-slate-500 dark:text-slate-400 flex items-center justify-between">
            <span>Prima de fichaje:</span>
            <span class="font-mono font-bold text-slate-700 dark:text-slate-200">0 € (No aplica en clausulazos)</span>
          </div>
        </div>

        <!-- Modal Actions -->
        <div class="pt-3 flex justify-end space-x-2 border-t border-slate-100 dark:border-slate-800">
          <button
            type="button"
            (click)="closeReleaseClauseModal()"
            class="px-4 py-2 text-xs font-semibold text-slate-600 dark:text-slate-400 hover:bg-slate-100 dark:hover:bg-slate-800 rounded-xl transition-colors cursor-pointer"
          >
            Cancelar
          </button>
          <button
            type="button"
            id="btn-confirm-release-clause-attempt"
            (click)="confirmReleaseClauseAttempt()"
            [disabled]="isSubmittingClause() || !game.canAction('placeOffer')"
            class="px-5 py-2 text-xs font-semibold bg-rose-600 hover:bg-rose-700 text-white rounded-xl disabled:opacity-50 cursor-pointer shadow-xs flex items-center space-x-1.5 transition-all"
          >
            @if (isSubmittingClause()) {
              <div class="w-3.5 h-3.5 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
              <span>Presentando...</span>
            } @else {
              <app-icon name="zap" [size]="15" />
              <span>Presentar Clausulazo</span>
            }
          </button>
        </div>
      </div>
    </div>
  }

  @if (viewingMarketPlayer; as player) {
    <app-player-profile
      [playerDefinitionId]="player.playerDefinitionId!"
      [playerName]="player.name"
      [dismissible]="false"
      (closed)="viewingMarketPlayer = null"
    />
  }
</div>
